/* ───────────────────────────────────────────────────────────────────────────
   GSG SHARED HELPERS - Must load before any brand widget.
   Attached to window so all brand widgets can reach them regardless of scope.
   ─────────────────────────────────────────────────────────────────────────── */

/* GSG 2026-08-20 v2: quantity-aware Add-to-Cart button label.
   The button must never understate the amount about to be added, and it
   must reproduce the REAL pricing semantics proven against the live rate
   engine on 2026-08-20:
     merchandise            x qty
     base freight (FPIA)    x qty        (300->600, 405->810 proven)
     residential/liftgate   flat per order  (katool $80: 380@1 -> 680@2 proven;
                                             free-base $80@1 = $80@2 proven;
                                             NAT res_la $150: 555@1 -> 960@2 proven)
     area rural             flat per order  ($200: 605@1 -> 1010@2 proven)
     area city              fee_first + fee_additional x (qty-1)
                                            ($200+$100: 605@1 -> 1110@2 proven)
   NEVER multiply a finished single-unit total by quantity - fees are not
   linear. Per-unit price displays (priceEl) stay per-unit. Display-only:
   no property, attribute, or rate contract is touched. Legacy BendPak /
   Triumph modules are deliberately NOT quantity-aware (zero active
   products use their templates; semantics unproven).
   Quantity is resolved inside the widget's own product form first so a
   sticky form or future secondary input cannot hijack the value. */
function gsgQtyFor(el) {
  var scope = null;
  if (el && el.closest) {
    scope = el.closest('form[action*="/cart/add"]') || el.closest('product-info') || el.closest('.product');
  }
  var q = (scope && scope.querySelector('input[name="quantity"], .quantity__input')) ||
          document.querySelector('form[action*="/cart/add"] input[name="quantity"], input[name="quantity"], .quantity__input');
  var v = q ? parseInt(q.value, 10) : 1;
  return (v && v > 0) ? v : 1;
}
function gsgWireQtyRefresh(el, fn) {
  var scope = null;
  if (el && el.closest) {
    scope = el.closest('form[action*="/cart/add"]') || el.closest('product-info') || el.closest('.product');
  }
  var q = (scope && scope.querySelector('input[name="quantity"], .quantity__input')) ||
          document.querySelector('form[action*="/cart/add"] input[name="quantity"], input[name="quantity"], .quantity__input');
  if (!q || q.dataset.gsgQtyWired) return;
  q.dataset.gsgQtyWired = '1';
  ['change','input'].forEach(function(ev){ q.addEventListener(ev, fn); });
}
function gsgMoney(n) {
  return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/* SELECTED-VARIANT PRICE (2026-08-26).
   `product.price` in Liquid is the LOWEST variant price, not the one the shopper
   is looking at. The widgets used to capture it once and stamp it over the real
   price on every updatePrice(), so a multi-variant product quoted its cheapest
   variant, and it re-broke every time the shopper answered a delivery question.
   This reads the price of the variant actually selected, right now, and falls
   back to the old value when there is no map or no match. */
window.gsgLivePrice = function (wrapper, fallback) {
  try {
    var raw = wrapper && wrapper.dataset ? (wrapper.dataset.variantPrices || '') : '';
    if (!raw) return fallback;
    var form = document.querySelector('form[action="/cart/add"]');
    var input = form ? (form.querySelector('[name="id"]')) : null;
    if (!input || !input.value) return fallback;
    var m = String(input.value).match(/(\d+)\s*$/);
    if (!m) return fallback;
    var want = m[1], parts = raw.split(',');
    for (var i = 0; i < parts.length; i++) {
      var kv = parts[i].split(':');
      if (kv[0] === want) {
        var p = parseFloat(kv[1]);
        return (isFinite(p) && p > 0) ? p : fallback;
      }
    }
  } catch (e) { /* never break the widget over a price lookup */ }
  return fallback;
};

window.gsgSetCartButtonState = function(addToCartBtn, enabled) {
  if (!addToCartBtn) return;
  addToCartBtn.setAttribute('aria-disabled', String(!enabled));
  if (enabled) {
    addToCartBtn.classList.remove('gsg-cart-locked');
  } else {
    addToCartBtn.classList.add('gsg-cart-locked');
  }
  // Hide dynamic checkout buttons (Shop Pay, PayPal, Affirm) until ready
  var dynamicCheckoutSelectors = [
    '.shopify-payment-button',
    '[data-shopify="payment-button"]',
    '.product-form__buttons .shopify-payment-button',
    '.shopify-payment-button__button'
  ];
  dynamicCheckoutSelectors.forEach(function(sel) {
    document.querySelectorAll(sel).forEach(function(el) {
      if (enabled) {
        el.classList.remove('gsg-dynamic-checkout-hidden');
      } else {
        el.classList.add('gsg-dynamic-checkout-hidden');
      }
    });
  });
};

// Single-widget guard. First widget to fire wins; others bail.
// Prevents double-attached click handlers if a product accidentally has
// multiple brand metafields.
window.gsgClaimWidget = function(addToCartBtn, widgetName) {
  if (!addToCartBtn) return true; // Nothing to guard, proceed normally
  if (addToCartBtn.dataset.gsgWidgetAttached) {
    console.warn('[GSG] ' + widgetName + ' widget skipped: ' + addToCartBtn.dataset.gsgWidgetAttached + ' already attached.');
    return false;
  }
  addToCartBtn.dataset.gsgWidgetAttached = widgetName;
  return true;
};
/* ================= WIDGET TREE V1 =================
   Foundation above this line. Every brand below is its OWN branch.
   Doctrine (shipping/WIDGET-TREE-V1.md): branches never share code,
   config, or metafields with each other - repetition is deliberate.
   The shared inventory reader below is foundation (pure readers of
   the #gsg-inventory-data script tag; used by the katool family). */
/* KATOOL DELIVERY WIDGET - PATH A (PICKUP CREDIT MODEL) + STOCK INDICATOR */

/* KATOOL INVENTORY - sourced from VARIANT METAFIELDS (katool-inventory-sync
   skill -> Matrixify import -> template emits #gsg-inventory-data JSON).
   The old hardcoded stock table and in-file SKU alias map are gone. This
   layer is BRAND-AGNOSTIC: any vendor whose variants carry the same
   metafields (inventory_status, supplier_reported_qty, pickup_inventory,
   pickup_inventory_updated_at) lights up identically. */
const KATOOL_LOW_STOCK = 3;

const gsgInventoryData = (function () {
  const el = document.getElementById('gsg-inventory-data');
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch (e) { return null; }
})();

function gsgVariantInventory(variantId) {
  if (!gsgInventoryData || !variantId) return null;
  const v = gsgInventoryData.variants && gsgInventoryData.variants[String(variantId)];
  if (!v) return null;
  return {
    status: v.status || null,
    qty: (typeof v.qty === 'number') ? v.qty : null,
    pickup: v.pickup || {},
    discontinued: v.pool === 'discontinued'
  };
}

function gsgRegistryEntry(key) {
  return (gsgInventoryData && gsgInventoryData.registry && gsgInventoryData.registry[key]) || null;
}

/* Up-front pickup availability line. Names are deduped because several
   registry keys share a city (two Houston, two Denver, two Linden blocks);
   the customer sees the city once, the dropdown still lists each address. */
function gsgPickupSummaryText(list) {
  const names = [];
  list.forEach(function (i) { if (names.indexOf(i.reg.name) === -1) names.push(i.reg.name); });
  if (!names.length) return '';
  if (names.length === 1) return 'In stock for pickup at ' + names[0];
  const rest = names.length - 3;
  return 'In stock for pickup at ' + names.length + ' warehouses: ' +
         names.slice(0, 3).join(', ') + (rest > 0 ? ' and ' + rest + ' more' : '');
}

function gsgPickupList(inv) {
  // Customer-eligible pickup: in-stock, registry-known warehouses only.
  // Zero-stock warehouses are HIDDEN by design.
  if (!inv) return [];
  return Object.keys(inv.pickup)
    .filter(function (k) { return inv.pickup[k] > 0 && gsgRegistryEntry(k); })
    .map(function (k) { return { key: k, qty: inv.pickup[k], reg: gsgRegistryEntry(k) }; })
    .sort(function (a, b) { return a.reg.name.localeCompare(b.reg.name); });
}

/* ============ BRANCH katool_v1 - Katool: charges, pickup network, inventory, credits ============
   Widget Tree V1 (2026-08-27). OWN BRANCH - edit freely, no other
   brand shares this code. Grown from the katool family module. */
document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.delivery-options-wrapper[data-flow="katool_v1"]');
  if (!wrapper) return;

  const buttons = wrapper.querySelectorAll('.delivery-option-btn');
  const pickupDropdown = wrapper.querySelector('.pickup-location-dropdown');
  const deliveryAddons = wrapper.querySelector('.delivery-addons');
  const locationSelect = wrapper.querySelector('#pickup-location');
  const addonButtons = wrapper.querySelectorAll('.addon-btn');
  const completeMessage = wrapper.querySelector('.delivery-complete-message');
  const stockBadge = wrapper.querySelector('.gsg-stock-badge');
  const stockWhere = wrapper.querySelector('.gsg-stock-where');

  /* The warehouse line is a POSITIVE claim, so it renders only from the same
     gate the pickup dropdown uses: fresh data, in-stock, registry-known
     warehouses. Stale, unknown, or discontinued -> nothing is claimed. */
  function updatePickupSummary(list) {
    if (!stockWhere) return;
    const txt = gsgPickupSummaryText(list || []);
    stockWhere.textContent = txt;
    stockWhere.style.display = txt ? 'block' : 'none';
  }

  const priceEl = document.querySelector('.price__regular .price-item--regular') ||
                  document.querySelector('.product__price') ||
                  document.querySelector('[data-product-price]');

  const buttonPriceEl = document.querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                        document.querySelector('.product-form__submit .price');

  const basePriceFallback = parseFloat(wrapper.dataset.basePrice) || 0;
  const deliveryRate   = parseFloat(wrapper.dataset.deliveryRate)   || 0;
  const residentialFee = parseFloat(wrapper.dataset.residentialFee) || 0;
  const liftgateFee    = parseFloat(wrapper.dataset.liftgateFee)    || 0;

  const productSku  = (wrapper.dataset.productSku  || '').trim();
  const variantSkus = (wrapper.dataset.variantSkus || '').split(',').map(s => s.trim()).filter(Boolean);

  function toVariantId(raw) {
    if (!raw) return null;
    const str = String(raw).trim();
    const match = str.match(/(\d+)\s*$/);
    return match ? parseInt(match[1], 10) : null;
  }

  const deliveryVariantId    = toVariantId(wrapper.dataset.deliveryVariantId);
  const residentialVariantId = toVariantId(wrapper.dataset.residentialVariantId);
  const liftgateVariantId    = toVariantId(wrapper.dataset.liftgateVariantId);

  let isDelivery    = null;
  let isResidential = null;
  let needsLiftgate = null;
  let activeVariantId = toVariantId(wrapper.dataset.initialVariantId) || null;
  const vendorName = wrapper.dataset.vendor || 'the manufacturer';
  /* RECEIVING CLASS (gsg.receiving_class, from the supplier quote sheet):
     parcel | ltl_liftgate_available | ltl_forklift_required |
     commercial_forklift_required | manual_quote. Empty = legacy flow.
     Kills the invalid-service bug: forklift-required items never sell
     liftgate; commercial-only items never sell residential. */
  const receivingClass = (wrapper.dataset.receivingClass || '').trim();
  /* PRICING CUTOVER FLAG (shop.metafields.custom.katool_pricing_cutover):
     false = legacy baked-price model (pickup credit, discount redirect).
     true  = MAP model: preview = price + selected freight + chosen fees;
     pickup = price alone; no credits, no discount codes. The cutover
     runbook flips the flag in the same window as the price import. */
  const pricingCutover = (wrapper.dataset.pricingCutover || '').trim() === 'true';
  const baseShippingCharge = parseFloat(wrapper.dataset.baseShippingCharge) || 0;
  const forkliftRequired = receivingClass === 'ltl_forklift_required' ||
                           receivingClass === 'commercial_forklift_required';
  let classBlocked = null; // warning reason currently blocking completion
  let isTerminal = false;  // forklift-required item + no forklift -> terminal freight
  const TERMINAL_METHOD = 'Freight to Local Terminal (you collect - closest terminal assigned after purchase)';

  const productForm = document.querySelector('form[action="/cart/add"]') ||
                      document.querySelector('product-form form') ||
                      document.querySelector('.product-form form');

  const addToCartBtn = document.querySelector('.product-form__submit') ||
                       (productForm ? productForm.querySelector('button[type="submit"]') : null);

  if (!window.gsgClaimWidget(addToCartBtn, 'katool_v1')) return;
  window.gsgSetCartButtonState(addToCartBtn, false);

  function renderStockBadge(status, missingSkus) {
    if (!stockBadge) return;
    stockBadge.className = 'gsg-stock-badge';
    switch (status) {
      case 'in':
        stockBadge.classList.add('gsg-stock--in');
        stockBadge.textContent = '✓ In Stock';
        break;
      case 'low':
        stockBadge.classList.add('gsg-stock--low');
        stockBadge.textContent = '⚠ Limited Stock - Order Soon';
        break;
      case 'out':
        stockBadge.classList.add('gsg-stock--out');
        stockBadge.textContent = '⏱ Backordered - Order Now to Reserve';
        stockBadge.title = vendorName + ' inventories refill fast. Order now to be first in line when new stock lands.';
        break;
      case 'partial':
        stockBadge.classList.add('gsg-stock--partial');
        stockBadge.textContent = '⏱ Partially Backordered - Order Now to Reserve';
        break;
      default:
        stockBadge.style.display = 'none';
        return;
    }
    stockBadge.style.display = 'inline-flex';
  }

  function updateStockBadge(location) {
    if (!stockBadge) return;
    if (!gsgInventoryData) { stockBadge.style.display = 'none'; return; }
    // A variant present in the map but carrying NO data at all (no status, no
    // qty, no timestamp, no pool) has no inventory feed behind it - every brand
    // outside the Katool feed. Show nothing: an absent badge claims nothing
    // either way, which is the honest state. Since 2026-08-31 an unknown or
    // under-review status is treated the same way (no badge) rather than
    // raising a confirmation prompt.
    const rawInv = gsgInventoryData.variants && gsgInventoryData.variants[String(activeVariantId)];
    if (rawInv && !rawInv.status && rawInv.qty == null && !rawInv.updated && !rawInv.pool) {
      stockBadge.style.display = 'none';
      return;
    }
    const inv = gsgVariantInventory(activeVariantId);
    if (!inv || !inv.status || inv.status === 'manual_review' || inv.status === 'not_mapped') {
      // REMOVED 2026-08-31 (Jordan): the availability-confirmation badge is
      // gone for good. When status is unknown or under review we now show NO
      // badge at all - an absent badge claims nothing either way, which is the
      // honest state, and it no longer reads as a warning about this product.
      // Age is no longer considered: a variant is judged on its data, not on
      // how long ago the sync ran.
      stockBadge.style.display = 'none';
      return;
    }
    if (inv.discontinued) {
      stockBadge.className = 'gsg-stock-badge gsg-stock--out';
      stockBadge.textContent = 'Out of Stock';
      stockBadge.title = '';
      stockBadge.style.display = 'inline-flex';
      return;
    }
    let status = null;
    if (location) {
      const q = inv.pickup[location] || 0;
      status = q === 0 ? 'out' : (q <= KATOOL_LOW_STOCK ? 'low' : 'in');
    } else if (inv.status === 'out_of_stock') {
      status = 'out';
    } else if (inv.status === 'in_stock' || inv.status === 'pickup_unavailable') {
      status = (inv.qty !== null && inv.qty <= KATOOL_LOW_STOCK) ? 'low' : 'in';
    }
    if (!status) { stockBadge.style.display = 'none'; return; }
    renderStockBadge(status);
  }

function updateLocationStockOptions() {
  if (!locationSelect) return;
  // No inventory data on this page (template not yet migrated, e.g.
  // regularshipping): leave the legacy markup untouched, never gate pickup.
  if (!gsgInventoryData) return;
  const inv = gsgVariantInventory(activeVariantId);
  const list = gsgPickupList(inv);

  // REMOVED 2026-08-31 (Jordan): the availability-confirmation note that used
  // to appear above the flow is gone. NOTE: the separate .gsg-confirm-note used
  // further down for "your delivery or pickup choice is confirmed at checkout"
  // is a DIFFERENT message and stays.
  updatePickupSummary(inv && inv.discontinued ? [] : list);

  const placeholder = Array.from(locationSelect.options).find(function (o) { return !o.value; });
  locationSelect.innerHTML = '';
  if (placeholder) locationSelect.appendChild(placeholder);
  list.forEach(function (item) {
    const opt = document.createElement('option');
    opt.value = item.key;
    opt.textContent = item.reg.name + ' - ' + item.reg.address +
      (item.qty <= KATOOL_LOW_STOCK ? ' (Low Stock)' : '');
    locationSelect.appendChild(opt);
  });

  if (inv && inv.discontinued) {
    wrapper.querySelectorAll('.delivery-option-btn').forEach(function (b) {
      b.disabled = true;
      b.title = 'This item is no longer available';
    });
    updateStockBadge(null);
    updatePickupSummary([]);
    return;
  }
  const pickupBtn = wrapper.querySelector('.delivery-option-btn[data-option="pickup"]');
  if (pickupBtn) {
    const available = list.length > 0;
    pickupBtn.disabled = !available;
    pickupBtn.title = available ? '' : 'Pickup is currently unavailable for this item';
    if (!available && isDelivery === false) {
      isDelivery = null;
      pickupBtn.classList.remove('selected');
      updateVisibility();
      checkCompletion();
    }
  }
}

  function checkCompletion() {
    let isComplete = false;
    if (isDelivery === true) {
      if (receivingClass === 'parcel') {
        isComplete = true;               // small parcel: no freight questions
      } else if (classBlocked) {
        isComplete = false;              // invalid receiving answer selected
      } else {
        isComplete = isResidential !== null && needsLiftgate !== null;
      }
    } else if (isDelivery === false) {
      isComplete = locationSelect && locationSelect.value !== '';
    }
    window.gsgSetCartButtonState(addToCartBtn, isComplete);
    if (completeMessage) completeMessage.style.display = isComplete ? 'flex' : 'none';
    return isComplete;
  }

  function updatePrice() {
    const basePrice = window.gsgLivePrice(wrapper, basePriceFallback);
    let total = basePrice;
    if (pricingCutover) {
      // MAP model: freight and fees are added at checkout; preview mirrors it
      if (isDelivery === true) {
        total = basePrice + baseShippingCharge;
        if (!isTerminal) {
          // terminal freight carries full freight but no fees
          if (isResidential === true) total += residentialFee;
          if (needsLiftgate === true) total += liftgateFee;
        }
      } else if (isDelivery === false) {
        total = basePrice;   // pickup = product price, nothing added
      }
    } else if (isDelivery === true) {
      if (isResidential === true) total += residentialFee;
      if (needsLiftgate === true) total += liftgateFee;
    } else if (isDelivery === false) {
      total = basePrice - deliveryRate;
    }
    const formattedPrice = '$' + total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (priceEl) priceEl.textContent = formattedPrice;
    if (buttonPriceEl) {
      /* quantity-aware button total, component-wise (see header comment).
         Non-cutover legacy pricing keeps the per-unit label - unproven. */
      var gsgQ = gsgQtyFor(wrapper);
      var gsgBtn = total;
      if (pricingCutover) {
        gsgBtn = basePrice * gsgQ;
        if (isDelivery === true) {
          gsgBtn += baseShippingCharge * gsgQ;
          if (!isTerminal) {
            if (isResidential === true) gsgBtn += residentialFee;
            if (needsLiftgate === true) gsgBtn += liftgateFee;
          }
        }
      }
      buttonPriceEl.innerHTML = '&nbsp;-&nbsp;&nbsp;' + gsgMoney(gsgBtn);
      gsgWireQtyRefresh(wrapper, updatePrice);
    }
  }

  function updateVisibility() {
    if (pickupDropdown) pickupDropdown.style.display = (isDelivery === false) ? 'block' : 'none';
    if (deliveryAddons) deliveryAddons.style.display = (isDelivery === true && receivingClass !== 'parcel') ? 'block' : 'none';
  }

  function showClassWarning(text) {
    classBlocked = text || null;
    let w = wrapper.querySelector('.gsg-class-warning');
    if (!w && deliveryAddons) {
      w = document.createElement('div');
      w.className = 'gsg-class-warning';
      deliveryAddons.appendChild(w);
    }
    if (w) {
      w.textContent = text || '';
      w.style.display = text ? 'block' : 'none';
    }
  }

  function showStepError(anchor, text) {
    if (!anchor) return;
    let e = anchor.querySelector(':scope > .gsg-step-error');
    if (!e) {
      e = document.createElement('div');
      e.className = 'gsg-step-error';
      anchor.appendChild(e);
    }
    e.textContent = text;
    e.style.display = 'block';
    clearTimeout(e._gsgTimer);
    e._gsgTimer = setTimeout(function () { e.style.display = 'none'; }, 4500);
  }

  function clearStepErrors() {
    wrapper.querySelectorAll('.gsg-step-error').forEach(function (e) { e.style.display = 'none'; });
    const atcErr = document.querySelector('.gsg-atc-error');
    if (atcErr) atcErr.style.display = 'none';
  }

  function showAtcError() {
    let err = document.querySelector('.gsg-atc-error');
    if (!err) {
      err = document.createElement('div');
      err.className = 'gsg-step-error gsg-atc-error';
      addToCartBtn.insertAdjacentElement('afterend', err);
    }
    err.textContent = isDelivery === null
      ? 'Please choose Delivery or Warehouse Pickup above first.'
      : 'Please answer the delivery questions above first.';
    err.style.display = 'block';
    clearTimeout(err._gsgTimer);
    err._gsgTimer = setTimeout(function () { err.style.display = 'none'; }, 4500);
  }

  function showTerminalNote(show) {
    let n = wrapper.querySelector('.gsg-terminal-note');
    if (!n && deliveryAddons) {
      n = document.createElement('div');
      n.className = 'gsg-class-warning gsg-terminal-note';
      deliveryAddons.appendChild(n);
    }
    if (n) {
      n.textContent = 'A forklift is required to receive this item, so liftgate delivery is not available. No problem: we ship it to the freight terminal closest to your address and you pick it up there. The terminal loads your vehicle or trailer for you.';
      n.style.display = show ? 'block' : 'none';
    }
  }

  // MAP-model guidance: the checkout method choice is authoritative
  if (pricingCutover) {
    // Delivery button carries the per-product freight amount (varies by
    // product); "Standard" removed per Jordan
    wrapper.querySelectorAll('.delivery-option-btn[data-option="delivery"]').forEach(function (b) {
      if (b.disabled) return;
      b.textContent = baseShippingCharge > 0
        ? 'Delivery - $' + baseShippingCharge.toLocaleString('en-US', {maximumFractionDigits: 0})
        : 'Free Delivery';
    });
    const note = document.createElement('div');
    note.className = 'gsg-confirm-note';
    note.style.display = 'block';
    note.textContent = 'Your delivery or pickup choice is confirmed at checkout and applies to your whole order.';
    const title = wrapper.querySelector('.delivery-options-title');
    if (title && title.parentNode) title.parentNode.insertBefore(note, title.nextSibling);
  }

  // per-class UI prep
  if (forkliftRequired) {
    wrapper.querySelectorAll('.addon-btn[data-addon="liftgate"][data-value="no"]').forEach(function (b) {
      b.textContent = 'No - I do not have a forklift';
    });
  }
  if (receivingClass === 'manual_quote') {
    wrapper.querySelectorAll('.delivery-option-btn[data-option="delivery"]').forEach(function (b) {
      b.disabled = true;
      b.title = 'This item requires a custom freight quote. Contact us before ordering.';
    });
  }

  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (this.classList.contains('selected')) {
        // clicking the chosen method again steps back to no selection
        this.classList.remove('selected');
        isDelivery = null;
        isResidential = null;
        needsLiftgate = null;
        isTerminal = false;
        showTerminalNote(false);
        showClassWarning(null);
        clearStepErrors();
        addonButtons.forEach(function(ab) { ab.classList.remove('selected'); });
        if (locationSelect) locationSelect.value = '';
        updateVisibility();
        updatePrice();
        checkCompletion();
        updateStockBadge(null);
        return;
      }
      buttons.forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');
      isDelivery    = this.dataset.option === 'delivery';
      isResidential = null;
      needsLiftgate = null;
      isTerminal = false;
      showTerminalNote(false);
      showClassWarning(null);
      clearStepErrors();
      addonButtons.forEach(function(ab) { ab.classList.remove('selected'); });
      if (locationSelect) locationSelect.value = '';
      updateVisibility();
      updatePrice();
      checkCompletion();
      if (isDelivery) {
        updateStockBadge(null);
      } else {
        updateLocationStockOptions();
        if (stockBadge) stockBadge.style.display = 'none';
      }
    });
  });

  addonButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const addon = this.dataset.addon;
      const value = this.dataset.value;
      if (addon === 'liftgate' && isResidential === null) {
        // steps answer in order: no forklift answer before residential
        showStepError(this.closest('.delivery-addon-question'),
          'Please answer the residential address question first.');
        return;
      }
      if (this.classList.contains('selected')) {
        // clicking the chosen answer again un-answers it; anything
        // downstream resets too so the glow walks back with it
        clearStepErrors();
        this.classList.remove('selected');
        if (addon === 'residential') {
          isResidential = null;
          wrapper.querySelectorAll('.addon-btn[data-addon="liftgate"]').forEach(function(b) { b.classList.remove('selected'); });
          needsLiftgate = null;
        }
        if (addon === 'liftgate' || addon === 'residential') {
          isTerminal = false;
          showTerminalNote(false);
          showClassWarning(null);
        }
        if (addon === 'liftgate') needsLiftgate = null;
        updatePrice();
        checkCompletion();
        return;
      }
      clearStepErrors();
      wrapper.querySelectorAll('.addon-btn[data-addon="' + addon + '"]').forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');
      if (addon === 'residential') {
        if (value === 'yes' && receivingClass === 'commercial_forklift_required') {
          isResidential = null;
          showClassWarning('This item is delivered to commercial addresses with a forklift only. Residential delivery is not available. Contact us for options.');
        } else {
          isResidential = value === 'yes';
          if (classBlocked && classBlocked.indexOf('commercial addresses') >= 0) showClassWarning(null);
        }
      } else if (addon === 'liftgate') {
        if (value === 'no' && forkliftRequired) {
          // No forklift on a forklift-required item: terminal freight
          // instead of a dead end. Full freight, no fees at checkout.
          needsLiftgate = false;
          isTerminal = true;
          showClassWarning(null);
          showTerminalNote(true);
        } else {
          needsLiftgate = value === 'no';
          isTerminal = false;
          showTerminalNote(false);
          if (classBlocked && classBlocked.indexOf('forklift is required') >= 0) showClassWarning(null);
        }
      }
      updatePrice();
      checkCompletion();
    });
  });

  if (locationSelect) {
    locationSelect.addEventListener('change', function() {
      checkCompletion();
      updateStockBadge(this.value);
    });
  }

  updateLocationStockOptions();

  document.addEventListener('variant:changed', function(e) {
    const variant = e.detail && e.detail.variant;
    if (variant && variant.id) {
      activeVariantId = toVariantId(variant.id);
      updateLocationStockOptions();
      updateStockBadge(isDelivery === false && locationSelect ? locationSelect.value : null);
      if (isDelivery === false) updateLocationStockOptions();
    }
  });

  const variantInput = productForm && (productForm.querySelector('input[name="id"]') || productForm.querySelector('select[name="id"]'));
  if (variantInput) {
    variantInput.addEventListener('change', function() {
      if (this.value) {
        activeVariantId = toVariantId(this.value);
        updateLocationStockOptions();
        updateStockBadge(isDelivery === false && locationSelect ? locationSelect.value : null);
        if (isDelivery === false) updateLocationStockOptions();
      }
    });
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (!productForm) {
        alert('Error: Could not find product form. Please refresh the page.');
        return;
      }

      if (!checkCompletion()) {
        showAtcError();
        return;
      }

      const mainVariantInput = productForm.querySelector('input[name="id"]') ||
                               productForm.querySelector('select[name="id"]');
      const mainVariantId = toVariantId(mainVariantInput ? mainVariantInput.value : null);

      if (!mainVariantId) {
        alert('Error: Could not find product variant.');
        return;
      }

      const quantityInput = document.querySelector('input[name="quantity"]') ||
                            document.querySelector('.quantity-input input') ||
                            document.querySelector('.quantity__input');
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

      const items = [];
      // Human-readable properties for staff/order display, PLUS
      // machine-readable _gsg_* properties (underscore-prefixed = hidden
      // from customer display) - the signal channel for Calcurates
      // conditions (Option B property-driven rates).
      // Visible property mirrors the EXACT checkout method name so the
      // order summary tells the customer which shipping line to select
      let shippingTypeLabel = isDelivery ? 'Delivery' : 'Pickup';
      if (pricingCutover && isDelivery === true && isTerminal) {
        shippingTypeLabel = TERMINAL_METHOD;
      } else if (pricingCutover && isDelivery === true) {
        shippingTypeLabel = isResidential
          ? (needsLiftgate ? 'Freight Delivery - Residential + Liftgate Service'
                           : 'Freight Delivery - Residential (forklift on site)')
          : (needsLiftgate ? 'Freight Delivery - Commercial + Liftgate Service'
                           : 'Freight Delivery - Commercial (forklift or loading dock)');
      } else if (pricingCutover && isDelivery === false && locationSelect && locationSelect.value) {
        const regE = gsgRegistryEntry(locationSelect.value);
        shippingTypeLabel = 'Warehouse Pickup - ' + (regE ? regE.name : locationSelect.value);
      }
      const mainItem = {
        id: mainVariantId,
        quantity: quantity,
        properties: {
          'Shipping Type': shippingTypeLabel,
          '_gsg_fulfillment_mode': isDelivery ? 'delivery' : 'pickup'
        }
      };

      if (isDelivery) {
        if (isTerminal) {
          // terminal freight: no fees, customer collects at the terminal
          mainItem.properties['Pickup Location'] = 'Nearest freight terminal';
          mainItem.properties['_gsg_terminal'] = 'yes';
        } else {
          if (isResidential) mainItem.properties['Residential Fee'] = 'Yes';
          if (needsLiftgate) mainItem.properties['Liftgate Service'] = 'Yes';
        }
        mainItem.properties['_gsg_residential'] = isResidential ? 'yes' : 'no';
        mainItem.properties['_gsg_liftgate'] = needsLiftgate ? 'yes' : 'no';
        if (receivingClass) mainItem.properties['_gsg_receiving_class'] = receivingClass;
      }
      if (!isDelivery && locationSelect && locationSelect.value) {
        const regEntry = gsgRegistryEntry(locationSelect.value);
        mainItem.properties['Pickup Location'] = regEntry
          ? regEntry.name + ' [' + locationSelect.value + ']'
          : locationSelect.value;
        mainItem.properties['_gsg_pickup_warehouse'] = locationSelect.value;
        const invNow = gsgVariantInventory(mainVariantId);
        const availableHere = invNow ? (invNow.pickup[locationSelect.value] || 0) : 0;
        if (availableHere > 0 && quantity > availableHere) {
          alert('Not enough stock at this warehouse for that quantity. Please reduce the quantity or choose delivery.');
          return;
        }
      }

      items.push(mainItem);

      if (isDelivery) {
        if (deliveryVariantId)                          items.push({ id: deliveryVariantId,    quantity: quantity });
        if (isResidential && residentialVariantId)      items.push({ id: residentialVariantId, quantity: 1 });
        if (needsLiftgate  && liftgateVariantId)        items.push({ id: liftgateVariantId,    quantity: 1 });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(data) { throw new Error(data.description || 'Cart add failed'); });
        }
        return response.json();
      })
      .then(() => {
        // Checkout lock signal: the SupaEasy delivery function reads this
        // cart attribute and hides every checkout method whose title does
        // not match. Only written when the label IS an exact method name;
        // unknown labels fail open (function hides nothing).
        if (pricingCutover && /^(Freight Delivery - |Warehouse Pickup - |Freight to Local Terminal)/.test(shippingTypeLabel)) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'gsg_selected_method': shippingTypeLabel } })
          }).catch(function() {}).then(function() {});
        }
      })
      .then(() => {
        if (!pricingCutover && !isDelivery && deliveryRate > 0) {
          // LEGACY ONLY: the pickup-credit discount dies at cutover
          const discountCode = 'PICKUP-CREDIT-' + Math.round(deliveryRate);
          window.location.href = '/discount/' + discountCode + '?redirect=/cart';
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open'));

          const cartIcon = document.querySelector('[data-cart-toggle], .cart-icon, .header__cart, a[href="/cart"]');
          if (cartIcon) cartIcon.click();
          else window.location.href = '/cart';
        }
      })
      .catch(function(error) {
        console.error('Error adding to cart:', error);
        alert('Error adding to cart: ' + error.message);
      });
    }, true);

    // The locked button has pointer-events none, so real clicks fall
    // through to the parent. Catch those and explain what is missing.
    (addToCartBtn.parentElement || document).addEventListener('click', function (e) {
      if (!addToCartBtn.classList.contains('gsg-cart-locked')) return;
      const r = addToCartBtn.getBoundingClientRect();
      if (e.clientX >= r.left && e.clientX <= r.right &&
          e.clientY >= r.top && e.clientY <= r.bottom) {
        showAtcError();
      }
    });
  }

  updateVisibility();
  updatePrice();
  checkCompletion();
  updateStockBadge(null);
});


/* ============ BRANCH fortisky_v1 - Fortisky: charges + Virginia Beach pickup ============
   Widget Tree V1 (2026-08-27). OWN BRANCH - edit freely, no other
   brand shares this code. Grown from the katool family module. */
document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.delivery-options-wrapper[data-flow="fortisky_v1"]');
  if (!wrapper) return;

  const buttons = wrapper.querySelectorAll('.delivery-option-btn');
  const pickupDropdown = wrapper.querySelector('.pickup-location-dropdown');
  const deliveryAddons = wrapper.querySelector('.delivery-addons');
  const locationSelect = wrapper.querySelector('#pickup-location');
  const addonButtons = wrapper.querySelectorAll('.addon-btn');
  const completeMessage = wrapper.querySelector('.delivery-complete-message');
  const stockBadge = wrapper.querySelector('.gsg-stock-badge');
  const stockWhere = wrapper.querySelector('.gsg-stock-where');

  /* The warehouse line is a POSITIVE claim, so it renders only from the same
     gate the pickup dropdown uses: fresh data, in-stock, registry-known
     warehouses. Stale, unknown, or discontinued -> nothing is claimed. */
  function updatePickupSummary(list) {
    if (!stockWhere) return;
    const txt = gsgPickupSummaryText(list || []);
    stockWhere.textContent = txt;
    stockWhere.style.display = txt ? 'block' : 'none';
  }

  const priceEl = document.querySelector('.price__regular .price-item--regular') ||
                  document.querySelector('.product__price') ||
                  document.querySelector('[data-product-price]');

  const buttonPriceEl = document.querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                        document.querySelector('.product-form__submit .price');

  const basePriceFallback = parseFloat(wrapper.dataset.basePrice) || 0;
  const deliveryRate   = parseFloat(wrapper.dataset.deliveryRate)   || 0;
  const residentialFee = parseFloat(wrapper.dataset.residentialFee) || 0;
  const liftgateFee    = parseFloat(wrapper.dataset.liftgateFee)    || 0;

  const productSku  = (wrapper.dataset.productSku  || '').trim();
  const variantSkus = (wrapper.dataset.variantSkus || '').split(',').map(s => s.trim()).filter(Boolean);

  function toVariantId(raw) {
    if (!raw) return null;
    const str = String(raw).trim();
    const match = str.match(/(\d+)\s*$/);
    return match ? parseInt(match[1], 10) : null;
  }

  const deliveryVariantId    = toVariantId(wrapper.dataset.deliveryVariantId);
  const residentialVariantId = toVariantId(wrapper.dataset.residentialVariantId);
  const liftgateVariantId    = toVariantId(wrapper.dataset.liftgateVariantId);

  let isDelivery    = null;
  let isResidential = null;
  let needsLiftgate = null;
  let activeVariantId = toVariantId(wrapper.dataset.initialVariantId) || null;
  const vendorName = wrapper.dataset.vendor || 'the manufacturer';
  /* RECEIVING CLASS (gsg.receiving_class, from the supplier quote sheet):
     parcel | ltl_liftgate_available | ltl_forklift_required |
     commercial_forklift_required | manual_quote. Empty = legacy flow.
     Kills the invalid-service bug: forklift-required items never sell
     liftgate; commercial-only items never sell residential. */
  const receivingClass = (wrapper.dataset.receivingClass || '').trim();
  /* PRICING CUTOVER FLAG (shop.metafields.custom.katool_pricing_cutover):
     false = legacy baked-price model (pickup credit, discount redirect).
     true  = MAP model: preview = price + selected freight + chosen fees;
     pickup = price alone; no credits, no discount codes. The cutover
     runbook flips the flag in the same window as the price import. */
  const pricingCutover = (wrapper.dataset.pricingCutover || '').trim() === 'true';
  const baseShippingCharge = parseFloat(wrapper.dataset.baseShippingCharge) || 0;
  const forkliftRequired = receivingClass === 'ltl_forklift_required' ||
                           receivingClass === 'commercial_forklift_required';
  let classBlocked = null; // warning reason currently blocking completion
  let isTerminal = false;  // forklift-required item + no forklift -> terminal freight
  const TERMINAL_METHOD = 'Freight to Local Terminal (you collect - closest terminal assigned after purchase)';

  const productForm = document.querySelector('form[action="/cart/add"]') ||
                      document.querySelector('product-form form') ||
                      document.querySelector('.product-form form');

  const addToCartBtn = document.querySelector('.product-form__submit') ||
                       (productForm ? productForm.querySelector('button[type="submit"]') : null);

  if (!window.gsgClaimWidget(addToCartBtn, 'fortisky_v1')) return;
  window.gsgSetCartButtonState(addToCartBtn, false);

  function renderStockBadge(status, missingSkus) {
    if (!stockBadge) return;
    stockBadge.className = 'gsg-stock-badge';
    switch (status) {
      case 'in':
        stockBadge.classList.add('gsg-stock--in');
        stockBadge.textContent = '✓ In Stock';
        break;
      case 'low':
        stockBadge.classList.add('gsg-stock--low');
        stockBadge.textContent = '⚠ Limited Stock - Order Soon';
        break;
      case 'out':
        stockBadge.classList.add('gsg-stock--out');
        stockBadge.textContent = '⏱ Backordered - Order Now to Reserve';
        stockBadge.title = vendorName + ' inventories refill fast. Order now to be first in line when new stock lands.';
        break;
      case 'partial':
        stockBadge.classList.add('gsg-stock--partial');
        stockBadge.textContent = '⏱ Partially Backordered - Order Now to Reserve';
        break;
      default:
        stockBadge.style.display = 'none';
        return;
    }
    stockBadge.style.display = 'inline-flex';
  }

  function updateStockBadge(location) {
    if (!stockBadge) return;
    if (!gsgInventoryData) { stockBadge.style.display = 'none'; return; }
    // A variant present in the map but carrying NO data at all (no status, no
    // qty, no timestamp, no pool) has no inventory feed behind it - every brand
    // outside the Katool feed. Show nothing: an absent badge claims nothing
    // either way, which is the honest state. Since 2026-08-31 an unknown or
    // under-review status is treated the same way (no badge) rather than
    // raising a confirmation prompt.
    const rawInv = gsgInventoryData.variants && gsgInventoryData.variants[String(activeVariantId)];
    if (rawInv && !rawInv.status && rawInv.qty == null && !rawInv.updated && !rawInv.pool) {
      stockBadge.style.display = 'none';
      return;
    }
    const inv = gsgVariantInventory(activeVariantId);
    if (!inv || !inv.status || inv.status === 'manual_review' || inv.status === 'not_mapped') {
      // REMOVED 2026-08-31 (Jordan): the availability-confirmation badge is
      // gone for good. When status is unknown or under review we now show NO
      // badge at all - an absent badge claims nothing either way, which is the
      // honest state, and it no longer reads as a warning about this product.
      // Age is no longer considered: a variant is judged on its data, not on
      // how long ago the sync ran.
      stockBadge.style.display = 'none';
      return;
    }
    if (inv.discontinued) {
      stockBadge.className = 'gsg-stock-badge gsg-stock--out';
      stockBadge.textContent = 'Out of Stock';
      stockBadge.title = '';
      stockBadge.style.display = 'inline-flex';
      return;
    }
    let status = null;
    if (location) {
      const q = inv.pickup[location] || 0;
      status = q === 0 ? 'out' : (q <= KATOOL_LOW_STOCK ? 'low' : 'in');
    } else if (inv.status === 'out_of_stock') {
      status = 'out';
    } else if (inv.status === 'in_stock' || inv.status === 'pickup_unavailable') {
      status = (inv.qty !== null && inv.qty <= KATOOL_LOW_STOCK) ? 'low' : 'in';
    }
    if (!status) { stockBadge.style.display = 'none'; return; }
    renderStockBadge(status);
  }

function updateLocationStockOptions() {
  if (!locationSelect) return;
  // No inventory data on this page (template not yet migrated, e.g.
  // regularshipping): leave the legacy markup untouched, never gate pickup.
  if (!gsgInventoryData) return;
  const inv = gsgVariantInventory(activeVariantId);
  const list = gsgPickupList(inv);

  // REMOVED 2026-08-31 (Jordan): the availability-confirmation note that used
  // to appear above the flow is gone. NOTE: the separate .gsg-confirm-note used
  // further down for "your delivery or pickup choice is confirmed at checkout"
  // is a DIFFERENT message and stays.
  updatePickupSummary(inv && inv.discontinued ? [] : list);

  const placeholder = Array.from(locationSelect.options).find(function (o) { return !o.value; });
  locationSelect.innerHTML = '';
  if (placeholder) locationSelect.appendChild(placeholder);
  list.forEach(function (item) {
    const opt = document.createElement('option');
    opt.value = item.key;
    opt.textContent = item.reg.name + ' - ' + item.reg.address +
      (item.qty <= KATOOL_LOW_STOCK ? ' (Low Stock)' : '');
    locationSelect.appendChild(opt);
  });

  if (inv && inv.discontinued) {
    wrapper.querySelectorAll('.delivery-option-btn').forEach(function (b) {
      b.disabled = true;
      b.title = 'This item is no longer available';
    });
    updateStockBadge(null);
    updatePickupSummary([]);
    return;
  }
  const pickupBtn = wrapper.querySelector('.delivery-option-btn[data-option="pickup"]');
  if (pickupBtn) {
    const available = list.length > 0;
    pickupBtn.disabled = !available;
    pickupBtn.title = available ? '' : 'Pickup is currently unavailable for this item';
    if (!available && isDelivery === false) {
      isDelivery = null;
      pickupBtn.classList.remove('selected');
      updateVisibility();
      checkCompletion();
    }
  }
}

  function checkCompletion() {
    let isComplete = false;
    if (isDelivery === true) {
      if (receivingClass === 'parcel') {
        isComplete = true;               // small parcel: no freight questions
      } else if (classBlocked) {
        isComplete = false;              // invalid receiving answer selected
      } else {
        isComplete = isResidential !== null && needsLiftgate !== null;
      }
    } else if (isDelivery === false) {
      isComplete = locationSelect && locationSelect.value !== '';
    }
    window.gsgSetCartButtonState(addToCartBtn, isComplete);
    if (completeMessage) completeMessage.style.display = isComplete ? 'flex' : 'none';
    return isComplete;
  }

  function updatePrice() {
    const basePrice = window.gsgLivePrice(wrapper, basePriceFallback);
    let total = basePrice;
    if (pricingCutover) {
      // MAP model: freight and fees are added at checkout; preview mirrors it
      if (isDelivery === true) {
        total = basePrice + baseShippingCharge;
        if (!isTerminal) {
          // terminal freight carries full freight but no fees
          if (isResidential === true) total += residentialFee;
          if (needsLiftgate === true) total += liftgateFee;
        }
      } else if (isDelivery === false) {
        total = basePrice;   // pickup = product price, nothing added
      }
    } else if (isDelivery === true) {
      if (isResidential === true) total += residentialFee;
      if (needsLiftgate === true) total += liftgateFee;
    } else if (isDelivery === false) {
      total = basePrice - deliveryRate;
    }
    const formattedPrice = '$' + total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (priceEl) priceEl.textContent = formattedPrice;
    if (buttonPriceEl) {
      /* quantity-aware button total, component-wise (see header comment).
         Non-cutover legacy pricing keeps the per-unit label - unproven. */
      var gsgQ = gsgQtyFor(wrapper);
      var gsgBtn = total;
      if (pricingCutover) {
        gsgBtn = basePrice * gsgQ;
        if (isDelivery === true) {
          gsgBtn += baseShippingCharge * gsgQ;
          if (!isTerminal) {
            if (isResidential === true) gsgBtn += residentialFee;
            if (needsLiftgate === true) gsgBtn += liftgateFee;
          }
        }
      }
      buttonPriceEl.innerHTML = '&nbsp;-&nbsp;&nbsp;' + gsgMoney(gsgBtn);
      gsgWireQtyRefresh(wrapper, updatePrice);
    }
  }

  function updateVisibility() {
    if (pickupDropdown) pickupDropdown.style.display = (isDelivery === false) ? 'block' : 'none';
    if (deliveryAddons) deliveryAddons.style.display = (isDelivery === true && receivingClass !== 'parcel') ? 'block' : 'none';
  }

  function showClassWarning(text) {
    classBlocked = text || null;
    let w = wrapper.querySelector('.gsg-class-warning');
    if (!w && deliveryAddons) {
      w = document.createElement('div');
      w.className = 'gsg-class-warning';
      deliveryAddons.appendChild(w);
    }
    if (w) {
      w.textContent = text || '';
      w.style.display = text ? 'block' : 'none';
    }
  }

  function showStepError(anchor, text) {
    if (!anchor) return;
    let e = anchor.querySelector(':scope > .gsg-step-error');
    if (!e) {
      e = document.createElement('div');
      e.className = 'gsg-step-error';
      anchor.appendChild(e);
    }
    e.textContent = text;
    e.style.display = 'block';
    clearTimeout(e._gsgTimer);
    e._gsgTimer = setTimeout(function () { e.style.display = 'none'; }, 4500);
  }

  function clearStepErrors() {
    wrapper.querySelectorAll('.gsg-step-error').forEach(function (e) { e.style.display = 'none'; });
    const atcErr = document.querySelector('.gsg-atc-error');
    if (atcErr) atcErr.style.display = 'none';
  }

  function showAtcError() {
    let err = document.querySelector('.gsg-atc-error');
    if (!err) {
      err = document.createElement('div');
      err.className = 'gsg-step-error gsg-atc-error';
      addToCartBtn.insertAdjacentElement('afterend', err);
    }
    err.textContent = isDelivery === null
      ? 'Please choose Delivery or Warehouse Pickup above first.'
      : 'Please answer the delivery questions above first.';
    err.style.display = 'block';
    clearTimeout(err._gsgTimer);
    err._gsgTimer = setTimeout(function () { err.style.display = 'none'; }, 4500);
  }

  function showTerminalNote(show) {
    let n = wrapper.querySelector('.gsg-terminal-note');
    if (!n && deliveryAddons) {
      n = document.createElement('div');
      n.className = 'gsg-class-warning gsg-terminal-note';
      deliveryAddons.appendChild(n);
    }
    if (n) {
      n.textContent = 'A forklift is required to receive this item, so liftgate delivery is not available. No problem: we ship it to the freight terminal closest to your address and you pick it up there. The terminal loads your vehicle or trailer for you.';
      n.style.display = show ? 'block' : 'none';
    }
  }

  // MAP-model guidance: the checkout method choice is authoritative
  if (pricingCutover) {
    // Delivery button carries the per-product freight amount (varies by
    // product); "Standard" removed per Jordan
    wrapper.querySelectorAll('.delivery-option-btn[data-option="delivery"]').forEach(function (b) {
      if (b.disabled) return;
      b.textContent = baseShippingCharge > 0
        ? 'Delivery - $' + baseShippingCharge.toLocaleString('en-US', {maximumFractionDigits: 0})
        : 'Free Delivery';
    });
    const note = document.createElement('div');
    note.className = 'gsg-confirm-note';
    note.style.display = 'block';
    note.textContent = 'Your delivery or pickup choice is confirmed at checkout and applies to your whole order.';
    const title = wrapper.querySelector('.delivery-options-title');
    if (title && title.parentNode) title.parentNode.insertBefore(note, title.nextSibling);
  }

  // per-class UI prep
  if (forkliftRequired) {
    wrapper.querySelectorAll('.addon-btn[data-addon="liftgate"][data-value="no"]').forEach(function (b) {
      b.textContent = 'No - I do not have a forklift';
    });
  }
  if (receivingClass === 'manual_quote') {
    wrapper.querySelectorAll('.delivery-option-btn[data-option="delivery"]').forEach(function (b) {
      b.disabled = true;
      b.title = 'This item requires a custom freight quote. Contact us before ordering.';
    });
  }

  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (this.classList.contains('selected')) {
        // clicking the chosen method again steps back to no selection
        this.classList.remove('selected');
        isDelivery = null;
        isResidential = null;
        needsLiftgate = null;
        isTerminal = false;
        showTerminalNote(false);
        showClassWarning(null);
        clearStepErrors();
        addonButtons.forEach(function(ab) { ab.classList.remove('selected'); });
        if (locationSelect) locationSelect.value = '';
        updateVisibility();
        updatePrice();
        checkCompletion();
        updateStockBadge(null);
        return;
      }
      buttons.forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');
      isDelivery    = this.dataset.option === 'delivery';
      isResidential = null;
      needsLiftgate = null;
      isTerminal = false;
      showTerminalNote(false);
      showClassWarning(null);
      clearStepErrors();
      addonButtons.forEach(function(ab) { ab.classList.remove('selected'); });
      if (locationSelect) locationSelect.value = '';
      updateVisibility();
      updatePrice();
      checkCompletion();
      if (isDelivery) {
        updateStockBadge(null);
      } else {
        updateLocationStockOptions();
        if (stockBadge) stockBadge.style.display = 'none';
      }
    });
  });

  addonButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const addon = this.dataset.addon;
      const value = this.dataset.value;
      if (addon === 'liftgate' && isResidential === null) {
        // steps answer in order: no forklift answer before residential
        showStepError(this.closest('.delivery-addon-question'),
          'Please answer the residential address question first.');
        return;
      }
      if (this.classList.contains('selected')) {
        // clicking the chosen answer again un-answers it; anything
        // downstream resets too so the glow walks back with it
        clearStepErrors();
        this.classList.remove('selected');
        if (addon === 'residential') {
          isResidential = null;
          wrapper.querySelectorAll('.addon-btn[data-addon="liftgate"]').forEach(function(b) { b.classList.remove('selected'); });
          needsLiftgate = null;
        }
        if (addon === 'liftgate' || addon === 'residential') {
          isTerminal = false;
          showTerminalNote(false);
          showClassWarning(null);
        }
        if (addon === 'liftgate') needsLiftgate = null;
        updatePrice();
        checkCompletion();
        return;
      }
      clearStepErrors();
      wrapper.querySelectorAll('.addon-btn[data-addon="' + addon + '"]').forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');
      if (addon === 'residential') {
        if (value === 'yes' && receivingClass === 'commercial_forklift_required') {
          isResidential = null;
          showClassWarning('This item is delivered to commercial addresses with a forklift only. Residential delivery is not available. Contact us for options.');
        } else {
          isResidential = value === 'yes';
          if (classBlocked && classBlocked.indexOf('commercial addresses') >= 0) showClassWarning(null);
        }
      } else if (addon === 'liftgate') {
        if (value === 'no' && forkliftRequired) {
          // No forklift on a forklift-required item: terminal freight
          // instead of a dead end. Full freight, no fees at checkout.
          needsLiftgate = false;
          isTerminal = true;
          showClassWarning(null);
          showTerminalNote(true);
        } else {
          needsLiftgate = value === 'no';
          isTerminal = false;
          showTerminalNote(false);
          if (classBlocked && classBlocked.indexOf('forklift is required') >= 0) showClassWarning(null);
        }
      }
      updatePrice();
      checkCompletion();
    });
  });

  if (locationSelect) {
    locationSelect.addEventListener('change', function() {
      checkCompletion();
      updateStockBadge(this.value);
    });
  }

  updateLocationStockOptions();

  document.addEventListener('variant:changed', function(e) {
    const variant = e.detail && e.detail.variant;
    if (variant && variant.id) {
      activeVariantId = toVariantId(variant.id);
      updateLocationStockOptions();
      updateStockBadge(isDelivery === false && locationSelect ? locationSelect.value : null);
      if (isDelivery === false) updateLocationStockOptions();
    }
  });

  const variantInput = productForm && (productForm.querySelector('input[name="id"]') || productForm.querySelector('select[name="id"]'));
  if (variantInput) {
    variantInput.addEventListener('change', function() {
      if (this.value) {
        activeVariantId = toVariantId(this.value);
        updateLocationStockOptions();
        updateStockBadge(isDelivery === false && locationSelect ? locationSelect.value : null);
        if (isDelivery === false) updateLocationStockOptions();
      }
    });
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (!productForm) {
        alert('Error: Could not find product form. Please refresh the page.');
        return;
      }

      if (!checkCompletion()) {
        showAtcError();
        return;
      }

      const mainVariantInput = productForm.querySelector('input[name="id"]') ||
                               productForm.querySelector('select[name="id"]');
      const mainVariantId = toVariantId(mainVariantInput ? mainVariantInput.value : null);

      if (!mainVariantId) {
        alert('Error: Could not find product variant.');
        return;
      }

      const quantityInput = document.querySelector('input[name="quantity"]') ||
                            document.querySelector('.quantity-input input') ||
                            document.querySelector('.quantity__input');
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

      const items = [];
      // Human-readable properties for staff/order display, PLUS
      // machine-readable _gsg_* properties (underscore-prefixed = hidden
      // from customer display) - the signal channel for Calcurates
      // conditions (Option B property-driven rates).
      // Visible property mirrors the EXACT checkout method name so the
      // order summary tells the customer which shipping line to select
      let shippingTypeLabel = isDelivery ? 'Delivery' : 'Pickup';
      if (pricingCutover && isDelivery === true && isTerminal) {
        shippingTypeLabel = TERMINAL_METHOD;
      } else if (pricingCutover && isDelivery === true) {
        shippingTypeLabel = isResidential
          ? (needsLiftgate ? 'Freight Delivery - Residential + Liftgate Service'
                           : 'Freight Delivery - Residential (forklift on site)')
          : (needsLiftgate ? 'Freight Delivery - Commercial + Liftgate Service'
                           : 'Freight Delivery - Commercial (forklift or loading dock)');
      } else if (pricingCutover && isDelivery === false && locationSelect && locationSelect.value) {
        const regE = gsgRegistryEntry(locationSelect.value);
        shippingTypeLabel = 'Warehouse Pickup - ' + (regE ? regE.name : locationSelect.value);
      }
      const mainItem = {
        id: mainVariantId,
        quantity: quantity,
        properties: {
          'Shipping Type': shippingTypeLabel,
          '_gsg_fulfillment_mode': isDelivery ? 'delivery' : 'pickup'
        }
      };

      if (isDelivery) {
        if (isTerminal) {
          // terminal freight: no fees, customer collects at the terminal
          mainItem.properties['Pickup Location'] = 'Nearest freight terminal';
          mainItem.properties['_gsg_terminal'] = 'yes';
        } else {
          if (isResidential) mainItem.properties['Residential Fee'] = 'Yes';
          if (needsLiftgate) mainItem.properties['Liftgate Service'] = 'Yes';
        }
        mainItem.properties['_gsg_residential'] = isResidential ? 'yes' : 'no';
        mainItem.properties['_gsg_liftgate'] = needsLiftgate ? 'yes' : 'no';
        if (receivingClass) mainItem.properties['_gsg_receiving_class'] = receivingClass;
      }
      if (!isDelivery && locationSelect && locationSelect.value) {
        const regEntry = gsgRegistryEntry(locationSelect.value);
        mainItem.properties['Pickup Location'] = regEntry
          ? regEntry.name + ' [' + locationSelect.value + ']'
          : locationSelect.value;
        mainItem.properties['_gsg_pickup_warehouse'] = locationSelect.value;
        const invNow = gsgVariantInventory(mainVariantId);
        const availableHere = invNow ? (invNow.pickup[locationSelect.value] || 0) : 0;
        if (availableHere > 0 && quantity > availableHere) {
          alert('Not enough stock at this warehouse for that quantity. Please reduce the quantity or choose delivery.');
          return;
        }
      }

      items.push(mainItem);

      if (isDelivery) {
        if (deliveryVariantId)                          items.push({ id: deliveryVariantId,    quantity: quantity });
        if (isResidential && residentialVariantId)      items.push({ id: residentialVariantId, quantity: 1 });
        if (needsLiftgate  && liftgateVariantId)        items.push({ id: liftgateVariantId,    quantity: 1 });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(data) { throw new Error(data.description || 'Cart add failed'); });
        }
        return response.json();
      })
      .then(() => {
        // Checkout lock signal: the SupaEasy delivery function reads this
        // cart attribute and hides every checkout method whose title does
        // not match. Only written when the label IS an exact method name;
        // unknown labels fail open (function hides nothing).
        if (pricingCutover && /^(Freight Delivery - |Warehouse Pickup - |Freight to Local Terminal)/.test(shippingTypeLabel)) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'gsg_selected_method': shippingTypeLabel } })
          }).catch(function() {}).then(function() {});
        }
      })
      .then(() => {
        if (!pricingCutover && !isDelivery && deliveryRate > 0) {
          // LEGACY ONLY: the pickup-credit discount dies at cutover
          const discountCode = 'PICKUP-CREDIT-' + Math.round(deliveryRate);
          window.location.href = '/discount/' + discountCode + '?redirect=/cart';
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open'));

          const cartIcon = document.querySelector('[data-cart-toggle], .cart-icon, .header__cart, a[href="/cart"]');
          if (cartIcon) cartIcon.click();
          else window.location.href = '/cart';
        }
      })
      .catch(function(error) {
        console.error('Error adding to cart:', error);
        alert('Error adding to cart: ' + error.message);
      });
    }, true);

    // The locked button has pointer-events none, so real clicks fall
    // through to the parent. Catch those and explain what is missing.
    (addToCartBtn.parentElement || document).addEventListener('click', function (e) {
      if (!addToCartBtn.classList.contains('gsg-cart-locked')) return;
      const r = addToCartBtn.getBoundingClientRect();
      if (e.clientX >= r.left && e.clientX <= r.right &&
          e.clientY >= r.top && e.clientY <= r.bottom) {
        showAtcError();
      }
    });
  }

  updateVisibility();
  updatePrice();
  checkCompletion();
  updateStockBadge(null);
});


/* ============ BRANCH challenger_v1 - Challenger: free everything (revocable here, one-branch change) ============
   Widget Tree V1 (2026-08-27). OWN BRANCH - edit freely, no other
   brand shares this code. Grown from the katool family module. */
document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.delivery-options-wrapper[data-flow="challenger_v1"]');
  if (!wrapper) return;

  const buttons = wrapper.querySelectorAll('.delivery-option-btn');
  const pickupDropdown = wrapper.querySelector('.pickup-location-dropdown');
  const deliveryAddons = wrapper.querySelector('.delivery-addons');
  const locationSelect = wrapper.querySelector('#pickup-location');
  const addonButtons = wrapper.querySelectorAll('.addon-btn');
  const completeMessage = wrapper.querySelector('.delivery-complete-message');
  const stockBadge = wrapper.querySelector('.gsg-stock-badge');
  const stockWhere = wrapper.querySelector('.gsg-stock-where');

  /* The warehouse line is a POSITIVE claim, so it renders only from the same
     gate the pickup dropdown uses: fresh data, in-stock, registry-known
     warehouses. Stale, unknown, or discontinued -> nothing is claimed. */
  function updatePickupSummary(list) {
    if (!stockWhere) return;
    const txt = gsgPickupSummaryText(list || []);
    stockWhere.textContent = txt;
    stockWhere.style.display = txt ? 'block' : 'none';
  }

  const priceEl = document.querySelector('.price__regular .price-item--regular') ||
                  document.querySelector('.product__price') ||
                  document.querySelector('[data-product-price]');

  const buttonPriceEl = document.querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                        document.querySelector('.product-form__submit .price');

  const basePriceFallback = parseFloat(wrapper.dataset.basePrice) || 0;
  const deliveryRate   = parseFloat(wrapper.dataset.deliveryRate)   || 0;
  const residentialFee = parseFloat(wrapper.dataset.residentialFee) || 0;
  const liftgateFee    = parseFloat(wrapper.dataset.liftgateFee)    || 0;

  const productSku  = (wrapper.dataset.productSku  || '').trim();
  const variantSkus = (wrapper.dataset.variantSkus || '').split(',').map(s => s.trim()).filter(Boolean);

  function toVariantId(raw) {
    if (!raw) return null;
    const str = String(raw).trim();
    const match = str.match(/(\d+)\s*$/);
    return match ? parseInt(match[1], 10) : null;
  }

  const deliveryVariantId    = toVariantId(wrapper.dataset.deliveryVariantId);
  const residentialVariantId = toVariantId(wrapper.dataset.residentialVariantId);
  const liftgateVariantId    = toVariantId(wrapper.dataset.liftgateVariantId);

  let isDelivery    = null;
  let isResidential = null;
  let needsLiftgate = null;
  let activeVariantId = toVariantId(wrapper.dataset.initialVariantId) || null;
  const vendorName = wrapper.dataset.vendor || 'the manufacturer';
  /* RECEIVING CLASS (gsg.receiving_class, from the supplier quote sheet):
     parcel | ltl_liftgate_available | ltl_forklift_required |
     commercial_forklift_required | manual_quote. Empty = legacy flow.
     Kills the invalid-service bug: forklift-required items never sell
     liftgate; commercial-only items never sell residential. */
  const receivingClass = (wrapper.dataset.receivingClass || '').trim();
  /* PRICING CUTOVER FLAG (shop.metafields.custom.katool_pricing_cutover):
     false = legacy baked-price model (pickup credit, discount redirect).
     true  = MAP model: preview = price + selected freight + chosen fees;
     pickup = price alone; no credits, no discount codes. The cutover
     runbook flips the flag in the same window as the price import. */
  const pricingCutover = (wrapper.dataset.pricingCutover || '').trim() === 'true';
  const baseShippingCharge = parseFloat(wrapper.dataset.baseShippingCharge) || 0;
  const forkliftRequired = receivingClass === 'ltl_forklift_required' ||
                           receivingClass === 'commercial_forklift_required';
  let classBlocked = null; // warning reason currently blocking completion
  let isTerminal = false;  // forklift-required item + no forklift -> terminal freight
  const TERMINAL_METHOD = 'Freight to Local Terminal (you collect - closest terminal assigned after purchase)';

  const productForm = document.querySelector('form[action="/cart/add"]') ||
                      document.querySelector('product-form form') ||
                      document.querySelector('.product-form form');

  const addToCartBtn = document.querySelector('.product-form__submit') ||
                       (productForm ? productForm.querySelector('button[type="submit"]') : null);

  if (!window.gsgClaimWidget(addToCartBtn, 'challenger_v1')) return;
  window.gsgSetCartButtonState(addToCartBtn, false);

  function renderStockBadge(status, missingSkus) {
    if (!stockBadge) return;
    stockBadge.className = 'gsg-stock-badge';
    switch (status) {
      case 'in':
        stockBadge.classList.add('gsg-stock--in');
        stockBadge.textContent = '✓ In Stock';
        break;
      case 'low':
        stockBadge.classList.add('gsg-stock--low');
        stockBadge.textContent = '⚠ Limited Stock - Order Soon';
        break;
      case 'out':
        stockBadge.classList.add('gsg-stock--out');
        stockBadge.textContent = '⏱ Backordered - Order Now to Reserve';
        stockBadge.title = vendorName + ' inventories refill fast. Order now to be first in line when new stock lands.';
        break;
      case 'partial':
        stockBadge.classList.add('gsg-stock--partial');
        stockBadge.textContent = '⏱ Partially Backordered - Order Now to Reserve';
        break;
      default:
        stockBadge.style.display = 'none';
        return;
    }
    stockBadge.style.display = 'inline-flex';
  }

  function updateStockBadge(location) {
    if (!stockBadge) return;
    if (!gsgInventoryData) { stockBadge.style.display = 'none'; return; }
    // A variant present in the map but carrying NO data at all (no status, no
    // qty, no timestamp, no pool) has no inventory feed behind it - every brand
    // outside the Katool feed. Show nothing: an absent badge claims nothing
    // either way, which is the honest state. Since 2026-08-31 an unknown or
    // under-review status is treated the same way (no badge) rather than
    // raising a confirmation prompt.
    const rawInv = gsgInventoryData.variants && gsgInventoryData.variants[String(activeVariantId)];
    if (rawInv && !rawInv.status && rawInv.qty == null && !rawInv.updated && !rawInv.pool) {
      stockBadge.style.display = 'none';
      return;
    }
    const inv = gsgVariantInventory(activeVariantId);
    if (!inv || !inv.status || inv.status === 'manual_review' || inv.status === 'not_mapped') {
      // REMOVED 2026-08-31 (Jordan): the availability-confirmation badge is
      // gone for good. When status is unknown or under review we now show NO
      // badge at all - an absent badge claims nothing either way, which is the
      // honest state, and it no longer reads as a warning about this product.
      // Age is no longer considered: a variant is judged on its data, not on
      // how long ago the sync ran.
      stockBadge.style.display = 'none';
      return;
    }
    if (inv.discontinued) {
      stockBadge.className = 'gsg-stock-badge gsg-stock--out';
      stockBadge.textContent = 'Out of Stock';
      stockBadge.title = '';
      stockBadge.style.display = 'inline-flex';
      return;
    }
    let status = null;
    if (location) {
      const q = inv.pickup[location] || 0;
      status = q === 0 ? 'out' : (q <= KATOOL_LOW_STOCK ? 'low' : 'in');
    } else if (inv.status === 'out_of_stock') {
      status = 'out';
    } else if (inv.status === 'in_stock' || inv.status === 'pickup_unavailable') {
      status = (inv.qty !== null && inv.qty <= KATOOL_LOW_STOCK) ? 'low' : 'in';
    }
    if (!status) { stockBadge.style.display = 'none'; return; }
    renderStockBadge(status);
  }

function updateLocationStockOptions() {
  if (!locationSelect) return;
  // No inventory data on this page (template not yet migrated, e.g.
  // regularshipping): leave the legacy markup untouched, never gate pickup.
  if (!gsgInventoryData) return;
  const inv = gsgVariantInventory(activeVariantId);
  const list = gsgPickupList(inv);

  // REMOVED 2026-08-31 (Jordan): the availability-confirmation note that used
  // to appear above the flow is gone. NOTE: the separate .gsg-confirm-note used
  // further down for "your delivery or pickup choice is confirmed at checkout"
  // is a DIFFERENT message and stays.
  updatePickupSummary(inv && inv.discontinued ? [] : list);

  const placeholder = Array.from(locationSelect.options).find(function (o) { return !o.value; });
  locationSelect.innerHTML = '';
  if (placeholder) locationSelect.appendChild(placeholder);
  list.forEach(function (item) {
    const opt = document.createElement('option');
    opt.value = item.key;
    opt.textContent = item.reg.name + ' - ' + item.reg.address +
      (item.qty <= KATOOL_LOW_STOCK ? ' (Low Stock)' : '');
    locationSelect.appendChild(opt);
  });

  if (inv && inv.discontinued) {
    wrapper.querySelectorAll('.delivery-option-btn').forEach(function (b) {
      b.disabled = true;
      b.title = 'This item is no longer available';
    });
    updateStockBadge(null);
    updatePickupSummary([]);
    return;
  }
  const pickupBtn = wrapper.querySelector('.delivery-option-btn[data-option="pickup"]');
  if (pickupBtn) {
    const available = list.length > 0;
    pickupBtn.disabled = !available;
    pickupBtn.title = available ? '' : 'Pickup is currently unavailable for this item';
    if (!available && isDelivery === false) {
      isDelivery = null;
      pickupBtn.classList.remove('selected');
      updateVisibility();
      checkCompletion();
    }
  }
}

  function checkCompletion() {
    let isComplete = false;
    if (isDelivery === true) {
      if (receivingClass === 'parcel') {
        isComplete = true;               // small parcel: no freight questions
      } else if (classBlocked) {
        isComplete = false;              // invalid receiving answer selected
      } else {
        isComplete = isResidential !== null && needsLiftgate !== null;
      }
    } else if (isDelivery === false) {
      isComplete = locationSelect && locationSelect.value !== '';
    }
    window.gsgSetCartButtonState(addToCartBtn, isComplete);
    if (completeMessage) completeMessage.style.display = isComplete ? 'flex' : 'none';
    return isComplete;
  }

  function updatePrice() {
    const basePrice = window.gsgLivePrice(wrapper, basePriceFallback);
    let total = basePrice;
    if (pricingCutover) {
      // MAP model: freight and fees are added at checkout; preview mirrors it
      if (isDelivery === true) {
        total = basePrice + baseShippingCharge;
        if (!isTerminal) {
          // terminal freight carries full freight but no fees
          if (isResidential === true) total += residentialFee;
          if (needsLiftgate === true) total += liftgateFee;
        }
      } else if (isDelivery === false) {
        total = basePrice;   // pickup = product price, nothing added
      }
    } else if (isDelivery === true) {
      if (isResidential === true) total += residentialFee;
      if (needsLiftgate === true) total += liftgateFee;
    } else if (isDelivery === false) {
      total = basePrice - deliveryRate;
    }
    const formattedPrice = '$' + total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (priceEl) priceEl.textContent = formattedPrice;
    if (buttonPriceEl) {
      /* quantity-aware button total, component-wise (see header comment).
         Non-cutover legacy pricing keeps the per-unit label - unproven. */
      var gsgQ = gsgQtyFor(wrapper);
      var gsgBtn = total;
      if (pricingCutover) {
        gsgBtn = basePrice * gsgQ;
        if (isDelivery === true) {
          gsgBtn += baseShippingCharge * gsgQ;
          if (!isTerminal) {
            if (isResidential === true) gsgBtn += residentialFee;
            if (needsLiftgate === true) gsgBtn += liftgateFee;
          }
        }
      }
      buttonPriceEl.innerHTML = '&nbsp;-&nbsp;&nbsp;' + gsgMoney(gsgBtn);
      gsgWireQtyRefresh(wrapper, updatePrice);
    }
  }

  function updateVisibility() {
    if (pickupDropdown) pickupDropdown.style.display = (isDelivery === false) ? 'block' : 'none';
    if (deliveryAddons) deliveryAddons.style.display = (isDelivery === true && receivingClass !== 'parcel') ? 'block' : 'none';
  }

  function showClassWarning(text) {
    classBlocked = text || null;
    let w = wrapper.querySelector('.gsg-class-warning');
    if (!w && deliveryAddons) {
      w = document.createElement('div');
      w.className = 'gsg-class-warning';
      deliveryAddons.appendChild(w);
    }
    if (w) {
      w.textContent = text || '';
      w.style.display = text ? 'block' : 'none';
    }
  }

  function showStepError(anchor, text) {
    if (!anchor) return;
    let e = anchor.querySelector(':scope > .gsg-step-error');
    if (!e) {
      e = document.createElement('div');
      e.className = 'gsg-step-error';
      anchor.appendChild(e);
    }
    e.textContent = text;
    e.style.display = 'block';
    clearTimeout(e._gsgTimer);
    e._gsgTimer = setTimeout(function () { e.style.display = 'none'; }, 4500);
  }

  function clearStepErrors() {
    wrapper.querySelectorAll('.gsg-step-error').forEach(function (e) { e.style.display = 'none'; });
    const atcErr = document.querySelector('.gsg-atc-error');
    if (atcErr) atcErr.style.display = 'none';
  }

  function showAtcError() {
    let err = document.querySelector('.gsg-atc-error');
    if (!err) {
      err = document.createElement('div');
      err.className = 'gsg-step-error gsg-atc-error';
      addToCartBtn.insertAdjacentElement('afterend', err);
    }
    err.textContent = isDelivery === null
      ? 'Please choose Delivery or Warehouse Pickup above first.'
      : 'Please answer the delivery questions above first.';
    err.style.display = 'block';
    clearTimeout(err._gsgTimer);
    err._gsgTimer = setTimeout(function () { err.style.display = 'none'; }, 4500);
  }

  function showTerminalNote(show) {
    let n = wrapper.querySelector('.gsg-terminal-note');
    if (!n && deliveryAddons) {
      n = document.createElement('div');
      n.className = 'gsg-class-warning gsg-terminal-note';
      deliveryAddons.appendChild(n);
    }
    if (n) {
      n.textContent = 'A forklift is required to receive this item, so liftgate delivery is not available. No problem: we ship it to the freight terminal closest to your address and you pick it up there. The terminal loads your vehicle or trailer for you.';
      n.style.display = show ? 'block' : 'none';
    }
  }

  // MAP-model guidance: the checkout method choice is authoritative
  if (pricingCutover) {
    // Delivery button carries the per-product freight amount (varies by
    // product); "Standard" removed per Jordan
    wrapper.querySelectorAll('.delivery-option-btn[data-option="delivery"]').forEach(function (b) {
      if (b.disabled) return;
      b.textContent = baseShippingCharge > 0
        ? 'Delivery - $' + baseShippingCharge.toLocaleString('en-US', {maximumFractionDigits: 0})
        : 'Free Delivery';
    });
    const note = document.createElement('div');
    note.className = 'gsg-confirm-note';
    note.style.display = 'block';
    note.textContent = 'Your delivery or pickup choice is confirmed at checkout and applies to your whole order.';
    const title = wrapper.querySelector('.delivery-options-title');
    if (title && title.parentNode) title.parentNode.insertBefore(note, title.nextSibling);
  }

  // per-class UI prep
  if (forkliftRequired) {
    wrapper.querySelectorAll('.addon-btn[data-addon="liftgate"][data-value="no"]').forEach(function (b) {
      b.textContent = 'No - I do not have a forklift';
    });
  }
  if (receivingClass === 'manual_quote') {
    wrapper.querySelectorAll('.delivery-option-btn[data-option="delivery"]').forEach(function (b) {
      b.disabled = true;
      b.title = 'This item requires a custom freight quote. Contact us before ordering.';
    });
  }

  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (this.classList.contains('selected')) {
        // clicking the chosen method again steps back to no selection
        this.classList.remove('selected');
        isDelivery = null;
        isResidential = null;
        needsLiftgate = null;
        isTerminal = false;
        showTerminalNote(false);
        showClassWarning(null);
        clearStepErrors();
        addonButtons.forEach(function(ab) { ab.classList.remove('selected'); });
        if (locationSelect) locationSelect.value = '';
        updateVisibility();
        updatePrice();
        checkCompletion();
        updateStockBadge(null);
        return;
      }
      buttons.forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');
      isDelivery    = this.dataset.option === 'delivery';
      isResidential = null;
      needsLiftgate = null;
      isTerminal = false;
      showTerminalNote(false);
      showClassWarning(null);
      clearStepErrors();
      addonButtons.forEach(function(ab) { ab.classList.remove('selected'); });
      if (locationSelect) locationSelect.value = '';
      updateVisibility();
      updatePrice();
      checkCompletion();
      if (isDelivery) {
        updateStockBadge(null);
      } else {
        updateLocationStockOptions();
        if (stockBadge) stockBadge.style.display = 'none';
      }
    });
  });

  addonButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const addon = this.dataset.addon;
      const value = this.dataset.value;
      if (addon === 'liftgate' && isResidential === null) {
        // steps answer in order: no forklift answer before residential
        showStepError(this.closest('.delivery-addon-question'),
          'Please answer the residential address question first.');
        return;
      }
      if (this.classList.contains('selected')) {
        // clicking the chosen answer again un-answers it; anything
        // downstream resets too so the glow walks back with it
        clearStepErrors();
        this.classList.remove('selected');
        if (addon === 'residential') {
          isResidential = null;
          wrapper.querySelectorAll('.addon-btn[data-addon="liftgate"]').forEach(function(b) { b.classList.remove('selected'); });
          needsLiftgate = null;
        }
        if (addon === 'liftgate' || addon === 'residential') {
          isTerminal = false;
          showTerminalNote(false);
          showClassWarning(null);
        }
        if (addon === 'liftgate') needsLiftgate = null;
        updatePrice();
        checkCompletion();
        return;
      }
      clearStepErrors();
      wrapper.querySelectorAll('.addon-btn[data-addon="' + addon + '"]').forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');
      if (addon === 'residential') {
        if (value === 'yes' && receivingClass === 'commercial_forklift_required') {
          isResidential = null;
          showClassWarning('This item is delivered to commercial addresses with a forklift only. Residential delivery is not available. Contact us for options.');
        } else {
          isResidential = value === 'yes';
          if (classBlocked && classBlocked.indexOf('commercial addresses') >= 0) showClassWarning(null);
        }
      } else if (addon === 'liftgate') {
        if (value === 'no' && forkliftRequired) {
          // No forklift on a forklift-required item: terminal freight
          // instead of a dead end. Full freight, no fees at checkout.
          needsLiftgate = false;
          isTerminal = true;
          showClassWarning(null);
          showTerminalNote(true);
        } else {
          needsLiftgate = value === 'no';
          isTerminal = false;
          showTerminalNote(false);
          if (classBlocked && classBlocked.indexOf('forklift is required') >= 0) showClassWarning(null);
        }
      }
      updatePrice();
      checkCompletion();
    });
  });

  if (locationSelect) {
    locationSelect.addEventListener('change', function() {
      checkCompletion();
      updateStockBadge(this.value);
    });
  }

  updateLocationStockOptions();

  document.addEventListener('variant:changed', function(e) {
    const variant = e.detail && e.detail.variant;
    if (variant && variant.id) {
      activeVariantId = toVariantId(variant.id);
      updateLocationStockOptions();
      updateStockBadge(isDelivery === false && locationSelect ? locationSelect.value : null);
      if (isDelivery === false) updateLocationStockOptions();
    }
  });

  const variantInput = productForm && (productForm.querySelector('input[name="id"]') || productForm.querySelector('select[name="id"]'));
  if (variantInput) {
    variantInput.addEventListener('change', function() {
      if (this.value) {
        activeVariantId = toVariantId(this.value);
        updateLocationStockOptions();
        updateStockBadge(isDelivery === false && locationSelect ? locationSelect.value : null);
        if (isDelivery === false) updateLocationStockOptions();
      }
    });
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (!productForm) {
        alert('Error: Could not find product form. Please refresh the page.');
        return;
      }

      if (!checkCompletion()) {
        showAtcError();
        return;
      }

      const mainVariantInput = productForm.querySelector('input[name="id"]') ||
                               productForm.querySelector('select[name="id"]');
      const mainVariantId = toVariantId(mainVariantInput ? mainVariantInput.value : null);

      if (!mainVariantId) {
        alert('Error: Could not find product variant.');
        return;
      }

      const quantityInput = document.querySelector('input[name="quantity"]') ||
                            document.querySelector('.quantity-input input') ||
                            document.querySelector('.quantity__input');
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

      const items = [];
      // Human-readable properties for staff/order display, PLUS
      // machine-readable _gsg_* properties (underscore-prefixed = hidden
      // from customer display) - the signal channel for Calcurates
      // conditions (Option B property-driven rates).
      // Visible property mirrors the EXACT checkout method name so the
      // order summary tells the customer which shipping line to select
      let shippingTypeLabel = isDelivery ? 'Delivery' : 'Pickup';
      if (pricingCutover && isDelivery === true && isTerminal) {
        shippingTypeLabel = TERMINAL_METHOD;
      } else if (pricingCutover && isDelivery === true) {
        shippingTypeLabel = isResidential
          ? (needsLiftgate ? 'Freight Delivery - Residential + Liftgate Service'
                           : 'Freight Delivery - Residential (forklift on site)')
          : (needsLiftgate ? 'Freight Delivery - Commercial + Liftgate Service'
                           : 'Freight Delivery - Commercial (forklift or loading dock)');
      } else if (pricingCutover && isDelivery === false && locationSelect && locationSelect.value) {
        const regE = gsgRegistryEntry(locationSelect.value);
        shippingTypeLabel = 'Warehouse Pickup - ' + (regE ? regE.name : locationSelect.value);
      }
      const mainItem = {
        id: mainVariantId,
        quantity: quantity,
        properties: {
          'Shipping Type': shippingTypeLabel,
          '_gsg_fulfillment_mode': isDelivery ? 'delivery' : 'pickup'
        }
      };

      if (isDelivery) {
        if (isTerminal) {
          // terminal freight: no fees, customer collects at the terminal
          mainItem.properties['Pickup Location'] = 'Nearest freight terminal';
          mainItem.properties['_gsg_terminal'] = 'yes';
        } else {
          if (isResidential) mainItem.properties['Residential Fee'] = 'Yes';
          if (needsLiftgate) mainItem.properties['Liftgate Service'] = 'Yes';
        }
        mainItem.properties['_gsg_residential'] = isResidential ? 'yes' : 'no';
        mainItem.properties['_gsg_liftgate'] = needsLiftgate ? 'yes' : 'no';
        if (receivingClass) mainItem.properties['_gsg_receiving_class'] = receivingClass;
      }
      if (!isDelivery && locationSelect && locationSelect.value) {
        const regEntry = gsgRegistryEntry(locationSelect.value);
        mainItem.properties['Pickup Location'] = regEntry
          ? regEntry.name + ' [' + locationSelect.value + ']'
          : locationSelect.value;
        mainItem.properties['_gsg_pickup_warehouse'] = locationSelect.value;
        const invNow = gsgVariantInventory(mainVariantId);
        const availableHere = invNow ? (invNow.pickup[locationSelect.value] || 0) : 0;
        if (availableHere > 0 && quantity > availableHere) {
          alert('Not enough stock at this warehouse for that quantity. Please reduce the quantity or choose delivery.');
          return;
        }
      }

      items.push(mainItem);

      if (isDelivery) {
        if (deliveryVariantId)                          items.push({ id: deliveryVariantId,    quantity: quantity });
        if (isResidential && residentialVariantId)      items.push({ id: residentialVariantId, quantity: 1 });
        if (needsLiftgate  && liftgateVariantId)        items.push({ id: liftgateVariantId,    quantity: 1 });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(data) { throw new Error(data.description || 'Cart add failed'); });
        }
        return response.json();
      })
      .then(() => {
        // Checkout lock signal: the SupaEasy delivery function reads this
        // cart attribute and hides every checkout method whose title does
        // not match. Only written when the label IS an exact method name;
        // unknown labels fail open (function hides nothing).
        if (pricingCutover && /^(Freight Delivery - |Warehouse Pickup - |Freight to Local Terminal)/.test(shippingTypeLabel)) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'gsg_selected_method': shippingTypeLabel } })
          }).catch(function() {}).then(function() {});
        }
      })
      .then(() => {
        if (!pricingCutover && !isDelivery && deliveryRate > 0) {
          // LEGACY ONLY: the pickup-credit discount dies at cutover
          const discountCode = 'PICKUP-CREDIT-' + Math.round(deliveryRate);
          window.location.href = '/discount/' + discountCode + '?redirect=/cart';
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open'));

          const cartIcon = document.querySelector('[data-cart-toggle], .cart-icon, .header__cart, a[href="/cart"]');
          if (cartIcon) cartIcon.click();
          else window.location.href = '/cart';
        }
      })
      .catch(function(error) {
        console.error('Error adding to cart:', error);
        alert('Error adding to cart: ' + error.message);
      });
    }, true);

    // The locked button has pointer-events none, so real clicks fall
    // through to the parent. Catch those and explain what is missing.
    (addToCartBtn.parentElement || document).addEventListener('click', function (e) {
      if (!addToCartBtn.classList.contains('gsg-cart-locked')) return;
      const r = addToCartBtn.getBoundingClientRect();
      if (e.clientX >= r.left && e.clientX <= r.right &&
          e.clientY >= r.top && e.clientY <= r.bottom) {
        showAtcError();
      }
    });
  }

  updateVisibility();
  updatePrice();
  checkCompletion();
  updateStockBadge(null);
});


/* BRANCH triumph_v1 - Triumph: forklift Q, NAT fees, regional surcharges (Widget Tree V1 2026-08-27). OWN BRANCH -
   edit freely, no other brand shares this code. Config comes from the
   shop brand_shipping_config metafield via #gsg-brand-config; new brands
   with the same question shapes are a registry entry, not new code. */
document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.delivery-options-wrapper[data-flow="triumph_v1"]');
  if (!wrapper) return;
  const cfgEl = document.getElementById('gsg-brand-config');
  if (!cfgEl) return;
  let cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  const basePriceFallback = parseFloat(wrapper.dataset.basePrice) || 0;
  const baseCharge = parseFloat(wrapper.dataset.baseShippingCharge) || 0;
  const receivingClass = (wrapper.dataset.receivingClass || '').trim();
  const productSku = (wrapper.dataset.productSku || '').trim().toUpperCase();
  const forkliftRequired = receivingClass === 'ltl_forklift_required' ||
                           receivingClass === 'commercial_forklift_required';
  const isParcel = receivingClass === 'parcel';  // gsgNatParcel: parts ship free ground, no LTL questions
  /* LIFTGATE CAPABILITY (brand-generic, opt-in via registry `liftgate: true`).
     Gate on receiving_class, NEVER on gsg.liftgate_ok. liftgate_ok is
     shipping-method / mixed-cart compatibility and is deliberately 'yes' on
     parcel items too, so it would wrongly ask a parcel buyer about a liftgate.
     Only an LTL item that can physically take a liftgate is asked. */
  const liftgateCapable = receivingClass === 'ltl_liftgate_available' && !!cfg.liftgate;
  /* A brand with no surcharge areas (Rotary) must not be shown a one-button
     area question it has to answer to proceed. Skip the step and pre-answer it. */
  const hasAreas = (cfg.areas || []).length > 0;
  const defaultArea = hasAreas ? null : 'none';
  const quoteSkus = ((cfg.quote_states || {}).skus || []).map(function(x){ return x.toUpperCase(); });
  const needsQuoteQuestion = quoteSkus.indexOf(productSku) >= 0;

  const productForm = document.querySelector('form[action="/cart/add"]') ||
                      document.querySelector('product-form form') ||
                      document.querySelector('.product-form form');
  const addToCartBtn = document.querySelector('.product-form__submit') ||
                       (productForm ? productForm.querySelector('button[type="submit"]') : null);
  if (!window.gsgClaimWidget(addToCartBtn, 'triumph_v1')) return;
  window.gsgSetCartButtonState(addToCartBtn, false);

  const priceEl = document.querySelector('.price__regular .price-item--regular') ||
                  document.querySelector('.product__price') ||
                  document.querySelector('[data-product-price]');
  const buttonPriceEl = document.querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                        document.querySelector('.product-form__submit .price');

  // ---- build markup (class contract: delivery-option-btn / addon-btn /
  // delivery-addon-question / .selected -> glow cascade + lock apply)
  const body = wrapper.querySelector('.gsg-nat-body');
  const chargeLabel = isParcel ? 'Free Shipping'
    : (baseCharge > 0
    ? 'Delivery - $' + baseCharge.toLocaleString('en-US', {maximumFractionDigits: 0})
    : 'Free Delivery');
  let html = '';
  html += '<div class="delivery-options-buttons">' +
    '<button type="button" class="delivery-option-btn" data-option="delivery">' + chargeLabel + '</button>' +
    ((cfg.pickups || []).length
      ? '<button type="button" class="delivery-option-btn" data-option="pickup">Warehouse Pickup</button>'
      : '') + '</div>';
  html += '<div class="delivery-addons" style="display:none;">';
  // Framing: on a zero-fee brand the questions are fulfilment planning, not upsells.
  if (cfg.questions_note) {
    html += '<div class="gsg-questions-note">' + cfg.questions_note + '</div>';
  }
  html += '<div class="delivery-addon-question" data-step="1">' +
    '<label>Is this a residential address, or a location with limited access for a large truck?</label>' +
    '<div class="addon-buttons">' +
    '<button type="button" class="addon-btn" data-addon="res_la" data-value="yes">Yes' +
      ((cfg.fees.res_la || 0) > 0 ? ' (+$' + cfg.fees.res_la + ')' : '') + '</button>' +
    '<button type="button" class="addon-btn" data-addon="res_la" data-value="no">No - Commercial with easy access</button>' +
    '</div></div>';
  if (hasAreas) {
    html += '<div class="delivery-addon-question" data-step="2">' +
      '<label>' + (cfg.area_question || 'Is your delivery address in any of these areas?') + '</label>' +
      '<div class="addon-buttons gsg-nat-areas">' +
      '<button type="button" class="addon-btn" data-addon="area" data-value="none">No, none of these</button>';
    (cfg.areas || []).forEach(function(a) {
      html += '<button type="button" class="addon-btn" data-addon="area" data-value="' + a.key + '">' + a.label + '</button>';
    });
    html += '</div></div>';
  }
  if (liftgateCapable) {
    const lgFee = (cfg.fees || {}).liftgate || 0;
    html += '<div class="delivery-addon-question" data-step="3">' +
      '<label>Do you have a forklift or loading dock to unload this from the truck?</label>' +
      '<div class="addon-buttons">' +
      '<button type="button" class="addon-btn" data-addon="liftgate" data-value="no">Yes - no liftgate needed</button>' +
      '<button type="button" class="addon-btn" data-addon="liftgate" data-value="yes">No - add liftgate service' +
        (lgFee > 0 ? ' (+$' + lgFee + ')' : '') + '</button>' +
      '</div></div>';
  }
  if (forkliftRequired) {
    html += '<div class="delivery-addon-question" data-step="3">' +
      '<label>Do you have a forklift, tractor, or other heavy machinery to unload this from the truck?</label>' +
      '<div class="addon-buttons">' +
      '<button type="button" class="addon-btn" data-addon="unload" data-value="yes">Yes - I can unload it</button>' +
      '<button type="button" class="addon-btn" data-addon="unload" data-value="no">No - I cannot unload it</button>' +
      '</div></div>';
  }
  if (needsQuoteQuestion) {
    html += '<div class="delivery-addon-question" data-step="4">' +
      '<label>' + ((cfg.quote_states || {}).question || 'Is your delivery address in a quote-required state?') + '</label>' +
      '<div class="addon-buttons">' +
      '<button type="button" class="addon-btn" data-addon="qstate" data-value="no">No</button>' +
      '<button type="button" class="addon-btn" data-addon="qstate" data-value="yes">Yes</button>' +
      '</div></div>';
  }
  html += '</div>';
  html += '<div class="pickup-location-dropdown" style="display:none;">' +
    '<label for="gsg-nat-pickup">Select Pickup Location:</label>' +
    '<select id="gsg-nat-pickup"><option value="" selected disabled>PLEASE SELECT A PICKUP LOCATION</option>';
  (cfg.pickups || []).forEach(function(pk) {
    html += '<option value="' + pk.key + '">' + pk.label.replace('Warehouse Pickup - ', '') + (pk.hours ? ' (' + pk.hours + ')' : '') + '</option>';
  });
  html += '</select>';
  if (cfg.pickup_note) {
    html += '<div class="pickup-info-box"><div class="pickup-info-title">Pickup Information</div>' +
      '<div class="pickup-info-list" style="font-size:13px;">' + cfg.pickup_note + '</div></div>';
  }
  html += '</div>';
  html += '<div class="delivery-complete-message" style="display:none;">All set! You may now add to cart.</div>';
  body.innerHTML = html;

  const buttons = wrapper.querySelectorAll('.delivery-option-btn');
  const addonButtons = wrapper.querySelectorAll('.addon-btn');
  const deliveryAddons = wrapper.querySelector('.delivery-addons');
  const pickupDropdown = wrapper.querySelector('.pickup-location-dropdown');
  const locationSelect = wrapper.querySelector('#gsg-nat-pickup');
  const completeMessage = wrapper.querySelector('.delivery-complete-message');

  let isDelivery = null, resLA = null, area = defaultArea, unloadOk = null, qstate = null, liftgate = null;

  function noteBox(cls) {
    let n = wrapper.querySelector('.' + cls);
    if (!n) {
      n = document.createElement('div');
      n.className = 'gsg-class-warning ' + cls;
      deliveryAddons.appendChild(n);
    }
    return n;
  }
  function showBlockNote(text) {
    const n = noteBox('gsg-nat-block');
    n.textContent = text || '';
    n.style.display = text ? 'block' : 'none';
  }
  function showStepError(anchorEl, text) {
    if (!anchorEl) return;
    let e = anchorEl.querySelector(':scope > .gsg-step-error');
    if (!e) {
      e = document.createElement('div');
      e.className = 'gsg-step-error';
      anchorEl.appendChild(e);
    }
    e.textContent = text;
    e.style.display = 'block';
    clearTimeout(e._t);
    e._t = setTimeout(function(){ e.style.display = 'none'; }, 4500);
  }
  function clearStepErrors() {
    wrapper.querySelectorAll('.gsg-step-error').forEach(function(e){ e.style.display = 'none'; });
    const g = document.querySelector('.gsg-atc-error'); if (g) g.style.display = 'none';
  }

  function blockedReason() {
    if (unloadOk === false) return 'unload';
    if (qstate === true) return 'quote_state';
    if (area === 'island') return 'island';
    return null;
  }
  function areaCfg() {
    return (cfg.areas || []).find(function(a){ return a.key === area; }) || null;
  }
  function selectedLabel() {
    if (isDelivery === false) {
      const pk = (cfg.pickups || []).find(function(p){ return p.key === locationSelect.value; });
      return pk ? pk.label : null;
    }
    if (isParcel) return 'Free Shipping';
    if (liftgateCapable && liftgate === true) {
      return resLA ? cfg.labels.res_lg : cfg.labels.com_lg;
    }
    let label = resLA ? cfg.labels.res_la : cfg.labels.com;
    const a = areaCfg();
    if (a && a.suffix_key && cfg.labels[a.suffix_key]) label += cfg.labels[a.suffix_key];
    return label;
  }
  function checkCompletion() {
    let complete = false;
    if (isDelivery === true) {
      complete = isParcel ? true
               : resLA !== null && area !== null && !blockedReason() &&
                 (!forkliftRequired || unloadOk === true) &&
                 (!liftgateCapable || liftgate !== null) &&
                 (!needsQuoteQuestion || qstate === false);
    } else if (isDelivery === false) {
      complete = !!(locationSelect && locationSelect.value);
    }
    window.gsgSetCartButtonState(addToCartBtn, complete);
    if (completeMessage) completeMessage.style.display = complete ? 'flex' : 'none';
    return complete;
  }
  function updatePrice() {
    const basePrice = window.gsgLivePrice(wrapper, basePriceFallback);
    let total = basePrice;
    if (isDelivery === true) {
      total = basePrice + baseCharge;
      if (resLA === true) total += (cfg.fees.res_la || 0);
      if (liftgateCapable && liftgate === true) total += ((cfg.fees || {}).liftgate || 0);
      const a = areaCfg();
      if (a && a.fee_type === 'flat') total += (a.fee || 0);
      if (a && a.fee_type === 'per_piece') total += (a.fee_first || 0);
    }
    const f = '$' + total.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    if (priceEl) priceEl.textContent = f;
    if (buttonPriceEl) {
      /* quantity-aware button total, component-wise (see header comment).
         Registry semantics: res_la flat/order; area flat -> fee once;
         area per_piece -> fee_first + fee_additional x (qty-1). */
      var gsgQ = gsgQtyFor(wrapper);
      var gsgBtn = basePrice * gsgQ;
      if (isDelivery === true) {
        gsgBtn += baseCharge * gsgQ;
        if (resLA === true) gsgBtn += (cfg.fees.res_la || 0);
        if (liftgateCapable && liftgate === true) gsgBtn += ((cfg.fees || {}).liftgate || 0);
        var gsgA = areaCfg();
        if (gsgA && gsgA.fee_type === 'flat') gsgBtn += (gsgA.fee || 0);
        if (gsgA && gsgA.fee_type === 'per_piece') gsgBtn += (gsgA.fee_first || 0) + (gsgA.fee_additional || 0) * (gsgQ - 1);
      }
      buttonPriceEl.innerHTML = '&nbsp;-&nbsp;&nbsp;' + gsgMoney(gsgBtn);
      gsgWireQtyRefresh(wrapper, updatePrice);
    }
  }
  function updateVisibility() {
    deliveryAddons.style.display = (isDelivery === true && !isParcel) ? 'block' : 'none';
    pickupDropdown.style.display = isDelivery === false ? 'block' : 'none';
  }
  function resetAnswers() {
    resLA = null; area = defaultArea; unloadOk = null; qstate = null; liftgate = null;
    addonButtons.forEach(function(b){ b.classList.remove('selected'); });
    showBlockNote(null);
    if (locationSelect) locationSelect.value = '';
  }

  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      clearStepErrors();
      if (this.classList.contains('selected')) {
        this.classList.remove('selected');
        isDelivery = null; resetAnswers();
        updateVisibility(); updatePrice(); checkCompletion();
        return;
      }
      buttons.forEach(function(b){ b.classList.remove('selected'); });
      this.classList.add('selected');
      isDelivery = this.dataset.option === 'delivery';
      resetAnswers();
      updateVisibility(); updatePrice(); checkCompletion();
    });
  });

  addonButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const addon = this.dataset.addon;
      const value = this.dataset.value;
      // order enforcement
      if (addon === 'area' && resLA === null) {
        showStepError(this.closest('.delivery-addon-question'),
          'Please answer the residential or limited access question first.');
        return;
      }
      if ((addon === 'unload' || addon === 'qstate' || addon === 'liftgate') && (resLA === null || area === null)) {
        showStepError(this.closest('.delivery-addon-question'),
          'Please answer the questions above first.');
        return;
      }
      clearStepErrors();
      if (this.classList.contains('selected')) {
        // deselect walks backwards; downstream resets
        this.classList.remove('selected');
        if (addon === 'res_la') { resLA = null; area = defaultArea; unloadOk = null; qstate = null; liftgate = null;
          wrapper.querySelectorAll('.addon-btn[data-addon="area"],.addon-btn[data-addon="unload"],.addon-btn[data-addon="qstate"],.addon-btn[data-addon="liftgate"]').forEach(function(b){ b.classList.remove('selected'); }); }
        if (addon === 'area') { area = null; unloadOk = null; qstate = null; liftgate = null;
          wrapper.querySelectorAll('.addon-btn[data-addon="unload"],.addon-btn[data-addon="qstate"],.addon-btn[data-addon="liftgate"]').forEach(function(b){ b.classList.remove('selected'); }); }
        if (addon === 'unload') unloadOk = null;
        if (addon === 'qstate') qstate = null;
        if (addon === 'liftgate') liftgate = null;
        showBlockNote(null);
        updatePrice(); checkCompletion();
        return;
      }
      wrapper.querySelectorAll('.addon-btn[data-addon="' + addon + '"]').forEach(function(b){ b.classList.remove('selected'); });
      this.classList.add('selected');
      if (addon === 'res_la') resLA = value === 'yes';
      if (addon === 'area') area = value;
      if (addon === 'unload') unloadOk = value === 'yes';
      if (addon === 'qstate') qstate = value === 'yes';
      if (addon === 'liftgate') liftgate = value === 'yes';
      const reason = blockedReason();
      if (reason === 'unload') {
        showBlockNote(cfg.unloading_note || 'Heavy unloading equipment is required for delivery. Choose warehouse pickup or contact us before ordering.');
      } else if (reason === 'island' || reason === 'quote_state') {
        showBlockNote('This delivery address needs a custom freight quote before ordering. Contact us and we will confirm your exact shipping cost, or choose warehouse pickup.');
      } else {
        showBlockNote(null);
      }
      updatePrice(); checkCompletion();
    });
  });

  if (locationSelect) {
    locationSelect.addEventListener('change', function(){ checkCompletion(); });
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (!productForm) { alert('Error: Could not find product form. Please refresh the page.'); return; }
      if (!checkCompletion()) {
        let err = document.querySelector('.gsg-atc-error');
        if (!err) {
          err = document.createElement('div');
          err.className = 'gsg-step-error gsg-atc-error';
          addToCartBtn.insertAdjacentElement('afterend', err);
        }
        err.textContent = isDelivery === null
          ? 'Please choose Delivery or Warehouse Pickup above first.'
          : (blockedReason() ? 'This selection needs pickup or a quote. See the note above, or contact us.'
                             : 'Please answer the delivery questions above first.');
        err.style.display = 'block';
        clearTimeout(err._t);
        err._t = setTimeout(function(){ err.style.display = 'none'; }, 4500);
        return;
      }
      const variantInput = productForm.querySelector('input[name="id"]') || productForm.querySelector('select[name="id"]');
      const variantId = variantInput ? parseInt(String(variantInput.value).match(/(\d+)\s*$/)[1], 10) : null;
      if (!variantId) { alert('Error: Could not find product variant.'); return; }
      const qtyInput = document.querySelector('input[name="quantity"]') ||
                       document.querySelector('.quantity-input input') || document.querySelector('.quantity__input');
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      const label = selectedLabel();
      const props = {'Shipping Type': label, '_gsg_fee_schedule': wrapper.dataset.feeSchedule,
                     '_gsg_fulfillment_mode': isDelivery ? 'delivery' : 'pickup'};
      if (isDelivery) {
        if (!isParcel) {
          props['_gsg_res_la'] = resLA ? 'yes' : 'no';
          props['_gsg_area'] = area;
          if (liftgateCapable) props['_gsg_liftgate'] = liftgate ? 'yes' : 'no';
        }
        if (receivingClass) props['_gsg_receiving_class'] = receivingClass;
      } else {
        const pk = (cfg.pickups || []).find(function(p){ return p.key === locationSelect.value; });
        props['Pickup Location'] = pk ? pk.label.replace('Warehouse Pickup - ', '') : locationSelect.value;
        props['_gsg_pickup_warehouse'] = locationSelect.value;
      }
      fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: [{id: variantId, quantity: quantity, properties: props}]})})
      .then(function(r){ if (!r.ok) return r.json().then(function(d){ throw new Error(d.description || 'Cart add failed'); }); return r.json(); })
      .then(function() {
        if (label && (/^(Freight Delivery - |Warehouse Pickup - )/.test(label) || label === 'Free Shipping')) {
          return fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({attributes: {'gsg_selected_method': label}})}).catch(function(){}).then(function(){});
        }
      })
      .then(function() {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        const cartIcon = document.querySelector('[data-cart-toggle], .cart-icon, .header__cart, a[href="/cart"]');
        if (cartIcon) cartIcon.click(); else window.location.href = '/cart';
      })
      .catch(function(error) { alert('Error adding to cart: ' + error.message); });
    }, true);

    (addToCartBtn.parentElement || document).addEventListener('click', function (e) {
      if (!addToCartBtn.classList.contains('gsg-cart-locked')) return;
      const r = addToCartBtn.getBoundingClientRect();
      if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
        addToCartBtn.click();
      }
    });
  }

  updateVisibility(); updatePrice(); checkCompletion();
});

/* BRANCH rotary_v1 - Rotary: free everything (revocable here), questions never price (Widget Tree V1 2026-08-27). OWN BRANCH -
   edit freely, no other brand shares this code. Config comes from the
   shop brand_shipping_config metafield via #gsg-brand-config; new brands
   with the same question shapes are a registry entry, not new code. */
document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.delivery-options-wrapper[data-flow="rotary_v1"]');
  if (!wrapper) return;
  const cfgEl = document.getElementById('gsg-brand-config');
  if (!cfgEl) return;
  let cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  const basePriceFallback = parseFloat(wrapper.dataset.basePrice) || 0;
  const baseCharge = parseFloat(wrapper.dataset.baseShippingCharge) || 0;
  const receivingClass = (wrapper.dataset.receivingClass || '').trim();
  const productSku = (wrapper.dataset.productSku || '').trim().toUpperCase();
  const forkliftRequired = receivingClass === 'ltl_forklift_required' ||
                           receivingClass === 'commercial_forklift_required';
  const isParcel = receivingClass === 'parcel';  // gsgNatParcel: parts ship free ground, no LTL questions
  /* LIFTGATE CAPABILITY (brand-generic, opt-in via registry `liftgate: true`).
     Gate on receiving_class, NEVER on gsg.liftgate_ok. liftgate_ok is
     shipping-method / mixed-cart compatibility and is deliberately 'yes' on
     parcel items too, so it would wrongly ask a parcel buyer about a liftgate.
     Only an LTL item that can physically take a liftgate is asked. */
  const liftgateCapable = receivingClass === 'ltl_liftgate_available' && !!cfg.liftgate;
  /* A brand with no surcharge areas (Rotary) must not be shown a one-button
     area question it has to answer to proceed. Skip the step and pre-answer it. */
  const hasAreas = (cfg.areas || []).length > 0;
  const defaultArea = hasAreas ? null : 'none';
  const quoteSkus = ((cfg.quote_states || {}).skus || []).map(function(x){ return x.toUpperCase(); });
  const needsQuoteQuestion = quoteSkus.indexOf(productSku) >= 0;

  const productForm = document.querySelector('form[action="/cart/add"]') ||
                      document.querySelector('product-form form') ||
                      document.querySelector('.product-form form');
  const addToCartBtn = document.querySelector('.product-form__submit') ||
                       (productForm ? productForm.querySelector('button[type="submit"]') : null);
  if (!window.gsgClaimWidget(addToCartBtn, 'rotary_v1')) return;
  window.gsgSetCartButtonState(addToCartBtn, false);

  const priceEl = document.querySelector('.price__regular .price-item--regular') ||
                  document.querySelector('.product__price') ||
                  document.querySelector('[data-product-price]');
  const buttonPriceEl = document.querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                        document.querySelector('.product-form__submit .price');

  // ---- build markup (class contract: delivery-option-btn / addon-btn /
  // delivery-addon-question / .selected -> glow cascade + lock apply)
  const body = wrapper.querySelector('.gsg-nat-body');
  const chargeLabel = isParcel ? 'Free Shipping'
    : (baseCharge > 0
    ? 'Delivery - $' + baseCharge.toLocaleString('en-US', {maximumFractionDigits: 0})
    : 'Free Delivery');
  let html = '';
  html += '<div class="delivery-options-buttons">' +
    '<button type="button" class="delivery-option-btn" data-option="delivery">' + chargeLabel + '</button>' +
    ((cfg.pickups || []).length
      ? '<button type="button" class="delivery-option-btn" data-option="pickup">Warehouse Pickup</button>'
      : '') + '</div>';
  html += '<div class="delivery-addons" style="display:none;">';
  // Framing: on a zero-fee brand the questions are fulfilment planning, not upsells.
  if (cfg.questions_note) {
    html += '<div class="gsg-questions-note">' + cfg.questions_note + '</div>';
  }
  html += '<div class="delivery-addon-question" data-step="1">' +
    '<label>Is this a residential address, or a location with limited access for a large truck?</label>' +
    '<div class="addon-buttons">' +
    '<button type="button" class="addon-btn" data-addon="res_la" data-value="yes">Yes' +
      ((cfg.fees.res_la || 0) > 0 ? ' (+$' + cfg.fees.res_la + ')' : '') + '</button>' +
    '<button type="button" class="addon-btn" data-addon="res_la" data-value="no">No - Commercial with easy access</button>' +
    '</div></div>';
  if (hasAreas) {
    html += '<div class="delivery-addon-question" data-step="2">' +
      '<label>' + (cfg.area_question || 'Is your delivery address in any of these areas?') + '</label>' +
      '<div class="addon-buttons gsg-nat-areas">' +
      '<button type="button" class="addon-btn" data-addon="area" data-value="none">No, none of these</button>';
    (cfg.areas || []).forEach(function(a) {
      html += '<button type="button" class="addon-btn" data-addon="area" data-value="' + a.key + '">' + a.label + '</button>';
    });
    html += '</div></div>';
  }
  if (liftgateCapable) {
    const lgFee = (cfg.fees || {}).liftgate || 0;
    html += '<div class="delivery-addon-question" data-step="3">' +
      '<label>Do you have a forklift or loading dock to unload this from the truck?</label>' +
      '<div class="addon-buttons">' +
      '<button type="button" class="addon-btn" data-addon="liftgate" data-value="no">Yes - no liftgate needed</button>' +
      '<button type="button" class="addon-btn" data-addon="liftgate" data-value="yes">No - add liftgate service' +
        (lgFee > 0 ? ' (+$' + lgFee + ')' : '') + '</button>' +
      '</div></div>';
  }
  if (forkliftRequired) {
    html += '<div class="delivery-addon-question" data-step="3">' +
      '<label>Do you have a forklift, tractor, or other heavy machinery to unload this from the truck?</label>' +
      '<div class="addon-buttons">' +
      '<button type="button" class="addon-btn" data-addon="unload" data-value="yes">Yes - I can unload it</button>' +
      '<button type="button" class="addon-btn" data-addon="unload" data-value="no">No - I cannot unload it</button>' +
      '</div></div>';
  }
  if (needsQuoteQuestion) {
    html += '<div class="delivery-addon-question" data-step="4">' +
      '<label>' + ((cfg.quote_states || {}).question || 'Is your delivery address in a quote-required state?') + '</label>' +
      '<div class="addon-buttons">' +
      '<button type="button" class="addon-btn" data-addon="qstate" data-value="no">No</button>' +
      '<button type="button" class="addon-btn" data-addon="qstate" data-value="yes">Yes</button>' +
      '</div></div>';
  }
  html += '</div>';
  html += '<div class="pickup-location-dropdown" style="display:none;">' +
    '<label for="gsg-nat-pickup">Select Pickup Location:</label>' +
    '<select id="gsg-nat-pickup"><option value="" selected disabled>PLEASE SELECT A PICKUP LOCATION</option>';
  (cfg.pickups || []).forEach(function(pk) {
    html += '<option value="' + pk.key + '">' + pk.label.replace('Warehouse Pickup - ', '') + (pk.hours ? ' (' + pk.hours + ')' : '') + '</option>';
  });
  html += '</select>';
  if (cfg.pickup_note) {
    html += '<div class="pickup-info-box"><div class="pickup-info-title">Pickup Information</div>' +
      '<div class="pickup-info-list" style="font-size:13px;">' + cfg.pickup_note + '</div></div>';
  }
  html += '</div>';
  html += '<div class="delivery-complete-message" style="display:none;">All set! You may now add to cart.</div>';
  body.innerHTML = html;

  const buttons = wrapper.querySelectorAll('.delivery-option-btn');
  const addonButtons = wrapper.querySelectorAll('.addon-btn');
  const deliveryAddons = wrapper.querySelector('.delivery-addons');
  const pickupDropdown = wrapper.querySelector('.pickup-location-dropdown');
  const locationSelect = wrapper.querySelector('#gsg-nat-pickup');
  const completeMessage = wrapper.querySelector('.delivery-complete-message');

  let isDelivery = null, resLA = null, area = defaultArea, unloadOk = null, qstate = null, liftgate = null;

  function noteBox(cls) {
    let n = wrapper.querySelector('.' + cls);
    if (!n) {
      n = document.createElement('div');
      n.className = 'gsg-class-warning ' + cls;
      deliveryAddons.appendChild(n);
    }
    return n;
  }
  function showBlockNote(text) {
    const n = noteBox('gsg-nat-block');
    n.textContent = text || '';
    n.style.display = text ? 'block' : 'none';
  }
  function showStepError(anchorEl, text) {
    if (!anchorEl) return;
    let e = anchorEl.querySelector(':scope > .gsg-step-error');
    if (!e) {
      e = document.createElement('div');
      e.className = 'gsg-step-error';
      anchorEl.appendChild(e);
    }
    e.textContent = text;
    e.style.display = 'block';
    clearTimeout(e._t);
    e._t = setTimeout(function(){ e.style.display = 'none'; }, 4500);
  }
  function clearStepErrors() {
    wrapper.querySelectorAll('.gsg-step-error').forEach(function(e){ e.style.display = 'none'; });
    const g = document.querySelector('.gsg-atc-error'); if (g) g.style.display = 'none';
  }

  function blockedReason() {
    if (unloadOk === false) return 'unload';
    if (qstate === true) return 'quote_state';
    if (area === 'island') return 'island';
    return null;
  }
  function areaCfg() {
    return (cfg.areas || []).find(function(a){ return a.key === area; }) || null;
  }
  function selectedLabel() {
    if (isDelivery === false) {
      const pk = (cfg.pickups || []).find(function(p){ return p.key === locationSelect.value; });
      return pk ? pk.label : null;
    }
    if (isParcel) return 'Free Shipping';
    if (liftgateCapable && liftgate === true) {
      return resLA ? cfg.labels.res_lg : cfg.labels.com_lg;
    }
    let label = resLA ? cfg.labels.res_la : cfg.labels.com;
    const a = areaCfg();
    if (a && a.suffix_key && cfg.labels[a.suffix_key]) label += cfg.labels[a.suffix_key];
    return label;
  }
  function checkCompletion() {
    let complete = false;
    if (isDelivery === true) {
      complete = isParcel ? true
               : resLA !== null && area !== null && !blockedReason() &&
                 (!forkliftRequired || unloadOk === true) &&
                 (!liftgateCapable || liftgate !== null) &&
                 (!needsQuoteQuestion || qstate === false);
    } else if (isDelivery === false) {
      complete = !!(locationSelect && locationSelect.value);
    }
    window.gsgSetCartButtonState(addToCartBtn, complete);
    if (completeMessage) completeMessage.style.display = complete ? 'flex' : 'none';
    return complete;
  }
  function updatePrice() {
    const basePrice = window.gsgLivePrice(wrapper, basePriceFallback);
    let total = basePrice;
    if (isDelivery === true) {
      total = basePrice + baseCharge;
      if (resLA === true) total += (cfg.fees.res_la || 0);
      if (liftgateCapable && liftgate === true) total += ((cfg.fees || {}).liftgate || 0);
      const a = areaCfg();
      if (a && a.fee_type === 'flat') total += (a.fee || 0);
      if (a && a.fee_type === 'per_piece') total += (a.fee_first || 0);
    }
    const f = '$' + total.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    if (priceEl) priceEl.textContent = f;
    if (buttonPriceEl) {
      /* quantity-aware button total, component-wise (see header comment).
         Registry semantics: res_la flat/order; area flat -> fee once;
         area per_piece -> fee_first + fee_additional x (qty-1). */
      var gsgQ = gsgQtyFor(wrapper);
      var gsgBtn = basePrice * gsgQ;
      if (isDelivery === true) {
        gsgBtn += baseCharge * gsgQ;
        if (resLA === true) gsgBtn += (cfg.fees.res_la || 0);
        if (liftgateCapable && liftgate === true) gsgBtn += ((cfg.fees || {}).liftgate || 0);
        var gsgA = areaCfg();
        if (gsgA && gsgA.fee_type === 'flat') gsgBtn += (gsgA.fee || 0);
        if (gsgA && gsgA.fee_type === 'per_piece') gsgBtn += (gsgA.fee_first || 0) + (gsgA.fee_additional || 0) * (gsgQ - 1);
      }
      buttonPriceEl.innerHTML = '&nbsp;-&nbsp;&nbsp;' + gsgMoney(gsgBtn);
      gsgWireQtyRefresh(wrapper, updatePrice);
    }
  }
  function updateVisibility() {
    deliveryAddons.style.display = (isDelivery === true && !isParcel) ? 'block' : 'none';
    pickupDropdown.style.display = isDelivery === false ? 'block' : 'none';
  }
  function resetAnswers() {
    resLA = null; area = defaultArea; unloadOk = null; qstate = null; liftgate = null;
    addonButtons.forEach(function(b){ b.classList.remove('selected'); });
    showBlockNote(null);
    if (locationSelect) locationSelect.value = '';
  }

  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      clearStepErrors();
      if (this.classList.contains('selected')) {
        this.classList.remove('selected');
        isDelivery = null; resetAnswers();
        updateVisibility(); updatePrice(); checkCompletion();
        return;
      }
      buttons.forEach(function(b){ b.classList.remove('selected'); });
      this.classList.add('selected');
      isDelivery = this.dataset.option === 'delivery';
      resetAnswers();
      updateVisibility(); updatePrice(); checkCompletion();
    });
  });

  addonButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const addon = this.dataset.addon;
      const value = this.dataset.value;
      // order enforcement
      if (addon === 'area' && resLA === null) {
        showStepError(this.closest('.delivery-addon-question'),
          'Please answer the residential or limited access question first.');
        return;
      }
      if ((addon === 'unload' || addon === 'qstate' || addon === 'liftgate') && (resLA === null || area === null)) {
        showStepError(this.closest('.delivery-addon-question'),
          'Please answer the questions above first.');
        return;
      }
      clearStepErrors();
      if (this.classList.contains('selected')) {
        // deselect walks backwards; downstream resets
        this.classList.remove('selected');
        if (addon === 'res_la') { resLA = null; area = defaultArea; unloadOk = null; qstate = null; liftgate = null;
          wrapper.querySelectorAll('.addon-btn[data-addon="area"],.addon-btn[data-addon="unload"],.addon-btn[data-addon="qstate"],.addon-btn[data-addon="liftgate"]').forEach(function(b){ b.classList.remove('selected'); }); }
        if (addon === 'area') { area = null; unloadOk = null; qstate = null; liftgate = null;
          wrapper.querySelectorAll('.addon-btn[data-addon="unload"],.addon-btn[data-addon="qstate"],.addon-btn[data-addon="liftgate"]').forEach(function(b){ b.classList.remove('selected'); }); }
        if (addon === 'unload') unloadOk = null;
        if (addon === 'qstate') qstate = null;
        if (addon === 'liftgate') liftgate = null;
        showBlockNote(null);
        updatePrice(); checkCompletion();
        return;
      }
      wrapper.querySelectorAll('.addon-btn[data-addon="' + addon + '"]').forEach(function(b){ b.classList.remove('selected'); });
      this.classList.add('selected');
      if (addon === 'res_la') resLA = value === 'yes';
      if (addon === 'area') area = value;
      if (addon === 'unload') unloadOk = value === 'yes';
      if (addon === 'qstate') qstate = value === 'yes';
      if (addon === 'liftgate') liftgate = value === 'yes';
      const reason = blockedReason();
      if (reason === 'unload') {
        showBlockNote(cfg.unloading_note || 'Heavy unloading equipment is required for delivery. Choose warehouse pickup or contact us before ordering.');
      } else if (reason === 'island' || reason === 'quote_state') {
        showBlockNote('This delivery address needs a custom freight quote before ordering. Contact us and we will confirm your exact shipping cost, or choose warehouse pickup.');
      } else {
        showBlockNote(null);
      }
      updatePrice(); checkCompletion();
    });
  });

  if (locationSelect) {
    locationSelect.addEventListener('change', function(){ checkCompletion(); });
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (!productForm) { alert('Error: Could not find product form. Please refresh the page.'); return; }
      if (!checkCompletion()) {
        let err = document.querySelector('.gsg-atc-error');
        if (!err) {
          err = document.createElement('div');
          err.className = 'gsg-step-error gsg-atc-error';
          addToCartBtn.insertAdjacentElement('afterend', err);
        }
        err.textContent = isDelivery === null
          ? 'Please choose Delivery or Warehouse Pickup above first.'
          : (blockedReason() ? 'This selection needs pickup or a quote. See the note above, or contact us.'
                             : 'Please answer the delivery questions above first.');
        err.style.display = 'block';
        clearTimeout(err._t);
        err._t = setTimeout(function(){ err.style.display = 'none'; }, 4500);
        return;
      }
      const variantInput = productForm.querySelector('input[name="id"]') || productForm.querySelector('select[name="id"]');
      const variantId = variantInput ? parseInt(String(variantInput.value).match(/(\d+)\s*$/)[1], 10) : null;
      if (!variantId) { alert('Error: Could not find product variant.'); return; }
      const qtyInput = document.querySelector('input[name="quantity"]') ||
                       document.querySelector('.quantity-input input') || document.querySelector('.quantity__input');
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      const label = selectedLabel();
      const props = {'Shipping Type': label, '_gsg_fee_schedule': wrapper.dataset.feeSchedule,
                     '_gsg_fulfillment_mode': isDelivery ? 'delivery' : 'pickup'};
      if (isDelivery) {
        if (!isParcel) {
          props['_gsg_res_la'] = resLA ? 'yes' : 'no';
          props['_gsg_area'] = area;
          if (liftgateCapable) props['_gsg_liftgate'] = liftgate ? 'yes' : 'no';
        }
        if (receivingClass) props['_gsg_receiving_class'] = receivingClass;
      } else {
        const pk = (cfg.pickups || []).find(function(p){ return p.key === locationSelect.value; });
        props['Pickup Location'] = pk ? pk.label.replace('Warehouse Pickup - ', '') : locationSelect.value;
        props['_gsg_pickup_warehouse'] = locationSelect.value;
      }
      fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: [{id: variantId, quantity: quantity, properties: props}]})})
      .then(function(r){ if (!r.ok) return r.json().then(function(d){ throw new Error(d.description || 'Cart add failed'); }); return r.json(); })
      .then(function() {
        if (label && (/^(Freight Delivery - |Warehouse Pickup - )/.test(label) || label === 'Free Shipping')) {
          return fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({attributes: {'gsg_selected_method': label}})}).catch(function(){}).then(function(){});
        }
      })
      .then(function() {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        const cartIcon = document.querySelector('[data-cart-toggle], .cart-icon, .header__cart, a[href="/cart"]');
        if (cartIcon) cartIcon.click(); else window.location.href = '/cart';
      })
      .catch(function(error) { alert('Error adding to cart: ' + error.message); });
    }, true);

    (addToCartBtn.parentElement || document).addEventListener('click', function (e) {
      if (!addToCartBtn.classList.contains('gsg-cart-locked')) return;
      const r = addToCartBtn.getBoundingClientRect();
      if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
        addToCartBtn.click();
      }
    });
  }

  updateVisibility(); updatePrice(); checkCompletion();
});

/* BRANCH forward_v1 - Forward: free everything, confirm-only (Widget Tree V1 2026-08-27). OWN BRANCH -
   edit freely, no other brand shares this code. Renders only
   on forklift-class products (template-gated): a single unloading
   confirmation. Everything else on the brand has no widget at all. */
document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.delivery-options-wrapper[data-flow="forward_v1"]');
  if (!wrapper) return;
  const productForm = document.querySelector('form[action="/cart/add"]') ||
                      document.querySelector('product-form form') ||
                      document.querySelector('.product-form form');
  const addToCartBtn = document.querySelector('.product-form__submit') ||
                       (productForm ? productForm.querySelector('button[type="submit"]') : null);
  if (!window.gsgClaimWidget(addToCartBtn, 'forward_v1')) return;
  window.gsgSetCartButtonState(addToCartBtn, false);

  const body = wrapper.querySelector('.gsg-free-body');
  body.innerHTML =
    '<div class="delivery-addons" style="display:block;">' +
    '<div class="delivery-addon-question" data-step="1">' +
    '<label>This item ships free by freight truck. Do you have a forklift or loading dock to unload it?</label>' +
    '<div class="addon-buttons">' +
    '<button type="button" class="addon-btn" data-addon="unload" data-value="yes">Yes - I can unload it</button>' +
    '<button type="button" class="addon-btn" data-addon="unload" data-value="no">No - contact me about delivery options</button>' +
    '</div></div></div>' +
    '<div class="delivery-complete-message" style="display:none;">All set! You may now add to cart.</div>';

  const completeMessage = wrapper.querySelector('.delivery-complete-message');
  let unloadOk = null;
  function note(show) {
    let n = wrapper.querySelector('.gsg-free-note');
    if (!n) {
      n = document.createElement('div');
      n.className = 'gsg-class-warning gsg-free-note';
      body.appendChild(n);
    }
    n.textContent = 'No problem. Order by phone or chat and we will arrange delivery options that work for your location before anything ships. Call ' +
      '855-498-2147 or use the chat bubble.';
    n.style.display = show ? 'block' : 'none';
  }
  function check() {
    const ok = unloadOk === true;
    window.gsgSetCartButtonState(addToCartBtn, ok);
    if (completeMessage) completeMessage.style.display = ok ? 'flex' : 'none';
  }
  wrapper.querySelectorAll('.addon-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (this.classList.contains('selected')) {
        this.classList.remove('selected');
        unloadOk = null; note(false); check();
        return;
      }
      wrapper.querySelectorAll('.addon-btn').forEach(function(b){ b.classList.remove('selected'); });
      this.classList.add('selected');
      unloadOk = this.dataset.value === 'yes';
      note(!unloadOk);
      check();
    });
  });
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (unloadOk !== true) {
        let err = document.querySelector('.gsg-atc-error');
        if (!err) {
          err = document.createElement('div');
          err.className = 'gsg-step-error gsg-atc-error';
          addToCartBtn.insertAdjacentElement('afterend', err);
        }
        err.textContent = 'Please confirm unloading above first.';
        err.style.display = 'block';
        clearTimeout(err._t);
        err._t = setTimeout(function(){ err.style.display = 'none'; }, 4500);
        return;
      }
      const variantInput = productForm.querySelector('input[name="id"]') || productForm.querySelector('select[name="id"]');
      const variantId = variantInput ? parseInt(String(variantInput.value).match(/(\d+)\s*$/)[1], 10) : null;
      if (!variantId) { alert('Error: Could not find product variant.'); return; }
      const qtyInput = document.querySelector('input[name="quantity"]') ||
                       document.querySelector('.quantity-input input') || document.querySelector('.quantity__input');
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: [{id: variantId, quantity: quantity,
          properties: {'Shipping Type': 'Free Shipping', '_gsg_fulfillment_mode': 'delivery',
                       '_gsg_unload_confirmed': 'yes'}}]})})
      .then(function(r){ if (!r.ok) return r.json().then(function(d){ throw new Error(d.description || 'Cart add failed'); }); return r.json(); })
      .then(function() {
        return fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({attributes: {'gsg_selected_method': 'Free Shipping'}})}).catch(function(){}).then(function(){});
      })
      .then(function() {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        const cartIcon = document.querySelector('[data-cart-toggle], .cart-icon, .header__cart, a[href="/cart"]');
        if (cartIcon) cartIcon.click(); else window.location.href = '/cart';
      })
      .catch(function(error) { alert('Error adding to cart: ' + error.message); });
    }, true);
    (addToCartBtn.parentElement || document).addEventListener('click', function (e) {
      if (!addToCartBtn.classList.contains('gsg-cart-locked')) return;
      const r = addToCartBtn.getBoundingClientRect();
      if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
        addToCartBtn.click();
      }
    });
  }
});

